webpackJsonp([7],{

/***/ "+A36":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"multiple":"","filterable":"","clearable":"","placeholder":"客户名称"},model:{value:(_vm.filters.customers),callback:function ($$v) {_vm.$set(_vm.filters, "customers", $$v)},expression:"filters.customers"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1),_vm._v(" "),_c('div',{staticClass:"duration"},[_c('span',{staticClass:"label"},[_vm._v("当前查询时间段：")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.dateRange[0])+" 至 "+_vm._s(_vm.dateRange[1]))])])],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("合作校平均学习时长排行榜")])]),_vm._v(" "),_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.durationTabActive),callback:function ($$v) {_vm.durationTabActive=$$v},expression:"durationTabActive"}},[_c('el-tab-pane',{attrs:{"label":"平均时长","name":"avg"}},[_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.timeRanking,"resizable":true,"loading":_vm.loading}})],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"总时长","name":"total"}},[_c('el-button',{attrs:{"id":"exportBtn","type":"primary","icon":"el-icon-download"},on:{"click":_vm.exportAllOrgDurs}},[_vm._v("导出全部")]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.totaltimeRanking,"resizable":true,"loading":_vm.loading}})],1)],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("合作校平均学习时长分布")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.timeSpread,"resizable":true,"loading":_vm.loading}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      时间排行\n      "),_c('small',[_vm._v("学习综合项排行榜")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/loudSpeakLearn/learnTime"}},[_vm._v("学习综合项排行榜")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("时间排行")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+g9V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/2wM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"content-header"},[(!_vm.fromClub())?_c('h1',[_vm._v("\n      Dashboard\n      "),_c('small',[_vm._v("Control panel")])]):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(!_vm.fromClub())?_c('section',{staticClass:"content"},[_vm._m(1)]):_c('section',{},[_c('h1',{staticStyle:{"font-size":"20px"}},[_vm._v("<==选择菜单查看语吧学习数据分析")])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("Dashboard")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-3 col-xs-6"},[_c('div',{staticClass:"small-box bg-aqua"},[_c('div',{staticClass:"inner"},[_c('h4',[_vm._v("时间排行")]),_vm._v(" "),_c('p',[_vm._v("数据")])]),_vm._v(" "),_c('a',{staticClass:"small-box-footer",attrs:{"href":"#/loudSpeakLearn/learnTime"}},[_vm._v("Go! "),_c('i',{staticClass:"fa fa-arrow-circle-right"})])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-xs-6"},[_c('div',{staticClass:"small-box bg-green"},[_c('div',{staticClass:"inner"},[_c('h4',[_vm._v("其它单项排行")]),_vm._v(" "),_c('p',[_vm._v("数据")])]),_vm._v(" "),_c('a',{staticClass:"small-box-footer",attrs:{"href":"#/loudSpeakLearn/learnAndSkill"}},[_vm._v("Go! "),_c('i',{staticClass:"fa fa-arrow-circle-right"})])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-xs-6"},[_c('div',{staticClass:"small-box bg-yellow"},[_c('div',{staticClass:"inner"},[_c('h4',[_vm._v("订单排行")]),_vm._v(" "),_c('p',[_vm._v("数据")])]),_vm._v(" "),_c('a',{staticClass:"small-box-footer",attrs:{"href":"#/loudSpeakOperate/order"}},[_vm._v("Go! "),_c('i',{staticClass:"fa fa-arrow-circle-right"})])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-3 col-xs-6"},[_c('div',{staticClass:"small-box bg-red"},[_c('div',{staticClass:"inner"},[_c('h4',[_vm._v("学校订单历史明细")]),_vm._v(" "),_c('p',[_vm._v("数据")])]),_vm._v(" "),_c('a',{staticClass:"small-box-footer",attrs:{"href":"#/loudSpeakOperate/user"}},[_vm._v("Go! "),_c('i',{staticClass:"fa fa-arrow-circle-right"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/foi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__("hRKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);

var localStorage = window.sessionStorage;
var JSON = window.JSON;

/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(name) {
    var value = localStorage.getItem(name);
    if (/^\{.*\}$/.test(value)) value = JSON.parse(value);
    return value;
  },
  set: function set(name, value) {
    if ((typeof value === "undefined" ? "undefined" : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(value)) === __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()({})) value = JSON.stringify(value);
    return localStorage.setItem(name, value);
  },
  remove: function remove(name) {
    return localStorage.removeItem(name);
  }
});

/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "2POs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"multiple":"","filterable":"","clearable":"","placeholder":"客户名称"},model:{value:(_vm.filters.customers),callback:function ($$v) {_vm.$set(_vm.filters, "customers", $$v)},expression:"filters.customers"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1),_vm._v(" "),_c('div',{staticClass:"duration"},[_c('span',{staticClass:"label"},[_vm._v("当前查询时间段：")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.dateRange[0])+" 至 "+_vm._s(_vm.dateRange[1]))])])],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("学习积分排行")])]),_vm._v(" "),_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.scoreTabActive),callback:function ($$v) {_vm.scoreTabActive=$$v},expression:"scoreTabActive"}},[_c('el-tab-pane',{attrs:{"label":"平均积分","name":"avg"}},[_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.scoreRanking,"resizable":true,"loading":_vm.loading}})],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"总积分","name":"total"}},[_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.totalscoreRanking,"resizable":true,"loading":_vm.loading}})],1)])],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("学习星星排行")])]),_vm._v(" "),_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.starTabActive),callback:function ($$v) {_vm.starTabActive=$$v},expression:"starTabActive"}},[_c('el-tab-pane',{attrs:{"label":"星星平均值","name":"avg"}},[_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.starRanking,"resizable":true,"loading":_vm.loading}})],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"星星总数","name":"total"}},[_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.totalstarRanking,"resizable":true,"loading":_vm.loading}})],1)])],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("语音质量分析")])]),_vm._v(" "),_c('div',{staticClass:"echart one-three"},[_c('IEcharts',{attrs:{"option":_vm.voicePrimary,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('div',{staticClass:"echart one-three"},[_c('IEcharts',{attrs:{"option":_vm.voiceMiddle,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('div',{staticClass:"echart one-three"},[_c('IEcharts',{attrs:{"option":_vm.voiceSenior,"resizable":true,"loading":_vm.loading}})],1)]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("技能分布")])]),_vm._v(" "),_c('div',{staticClass:"echart two-three"},[_c('IEcharts',{attrs:{"option":_vm.skillSpreadBL,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('div',{staticClass:"echart one-three"},[_c('IEcharts',{attrs:{"option":_vm.skillSpreadPie,"resizable":true,"loading":_vm.loading}})],1)]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"课程选择"},on:{"change":_vm.changeCourse},model:{value:(_vm.filters.modeId),callback:function ($$v) {_vm.$set(_vm.filters, "modeId", $$v)},expression:"filters.modeId"}},_vm._l((_vm.modeList),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.val,"value":item.key}})}),1),_vm._v(" "),_c('span',{staticClass:"header-text"},[_vm._v("课程分析")])],1),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.courseRanking,"resizable":true,"loading":_vm.loading1}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      其它单项排行\n      "),_c('small',[_vm._v("学习综合项排行榜")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/loudSpeakLearn/learnTime"}},[_vm._v("学习综合项排行榜")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("其它单项排行")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2eDF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "3YjS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fromClub),expression:"!fromClub"}]},[_c('h1',{staticClass:"login-title"},[_vm._v("Qooco DAS")]),_vm._v(" "),_c('el-form',{ref:"ruleForm2",staticClass:"demo-ruleForm login-container",attrs:{"model":_vm.ruleForm2,"rules":_vm.rules2,"label-position":"left","label-width":"0px"}},[_c('h3',{staticClass:"title"},[_vm._v("欢迎登录")]),_vm._v(" "),_c('h6',{directives:[{name:"show",rawName:"v-show",value:(_vm.msg),expression:"msg"}],staticClass:"errMsg"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"username"}},[_c('el-input',{attrs:{"type":"text","auto-complete":"off","placeholder":"账号"},model:{value:(_vm.ruleForm2.username),callback:function ($$v) {_vm.$set(_vm.ruleForm2, "username", $$v)},expression:"ruleForm2.username"}})],1),_vm._v(" "),_c('el-form-item',{attrs:{"prop":"password"}},[_c('el-input',{attrs:{"type":"password","auto-complete":"off","placeholder":"密码"},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.handleSubmit2($event)}},model:{value:(_vm.ruleForm2.password),callback:function ($$v) {_vm.$set(_vm.ruleForm2, "password", $$v)},expression:"ruleForm2.password"}})],1),_vm._v(" "),_c('el-checkbox',{staticClass:"remember",attrs:{"checked":""},model:{value:(_vm.checked),callback:function ($$v) {_vm.checked=$$v},expression:"checked"}},[_vm._v("记住密码")]),_vm._v(" "),_c('el-form-item',{staticStyle:{"width":"100%"}},[_c('el-button',{staticStyle:{"width":"100%"},attrs:{"type":"primary"},nativeOn:{"click":function($event){$event.preventDefault();return _vm.handleSubmit2($event)}}},[_vm._v("登录")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3lkS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_loud_speak_learn__ = __webpack_require__("Xood");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__ = __webpack_require__("r/qW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import {Loading} from 'element-ui'

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['customers', 'pickerOptions', 'orgTypes'])),
  data: function data() {
    return {
      currentDate: new Date(),
      filters: {
        customer: [],
        schoolId: [],
        dateRange: [],
        orgType: ''
      },

      loading: true,
      timeRanking: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '25%', y: '14%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: []
        },
        series: [{
          name: '时长（分钟）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },

      timeSpread: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '15%', y: '14%', width: '70%', height: '75%' },
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '学校（数目）',
          type: 'bar',
          data: [0, 0, 0, 0]
        }],
        color: ['rgb(91,155,213)']
      }
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_1_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this._loadLearnTimeData();
  },

  methods: {
    query: function query() {
      this._loadLearnTimeData(this.filters);
    },
    _loadLearnTimeData: function _loadLearnTimeData() {
      var _this = this;

      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_3_api_loud_speak_learn__["b" /* loadLearnTimeData */])(this.filters).then(function (res) {
        _this.loading = false;
        _this.timeRanking.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["j" /* withRank */])(res.duration_ranking.keys.reverse(), res.duration_ranking.ranks.reverse());
        _this.timeRanking.series[0].data = res.duration_ranking.values.reverse();
        _this.timeSpread.xAxis.data = res.duration_spread.keys;
        _this.timeSpread.series[0].data = res.duration_spread.values;
      }, function (msg) {
        _this.loading = false;
        _this._resetData();
        _this.$message.error(msg);
      });
    },
    _resetData: function _resetData() {
      this.timeRanking.yAxis.data = [];
      this.timeRanking.series[0].data = [];
      this.timeSpread.xAxis.data = [];
      this.timeSpread.series[0].data = [];
    }
  }
});

/***/ }),

/***/ "4j6V":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "77ao":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("fu2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_common_js_common_utils__ = __webpack_require__("tqEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_condition__ = __webpack_require__("tc/g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__ = __webpack_require__("r/qW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loaded: false,
      router: []
    };
  },

  computed: {
    filteredRouter: function filteredRouter() {
      var _this = this;

      // 巧口角色ROLE_QOOCO需要走权限hasPermission
      var router = this.router && this.router.filter(function (item) {
        return !item.hidden && (_this.$auth.check(item.meta.auth.roles) && !_this.isQooco() || _this.hasPermission('/das/' + item.name));
      });
      // console.log('----filtered-router------------->')
      // console.log(router)
      return router;
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    // window
    if (Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["c" /* fromClub */])()) {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.getScript('http://club.qooco.com/das/sessionId', function () {
        if (localStorage.getItem('lastClubSessionId') && localStorage.getItem('lastClubSessionId') !== window.sessionId) {
          _this2.logout();
        } else {
          if (document.body.height === 0) {
            window.location.reload();
          }
        }
      });
    }
    this.$nextTick(function () {
      window.AdminLTE();
    });
    __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').resize();
    this.router = this.$router.options.routes;
    // state setting
    this._setCustomers();
    this._setPickerOptions();
    this._setOrgTypes();
    this._setOrgClasses();
    this._setModeList();
  },

  methods: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
    toggleSidebar: function toggleSidebar() {
      __WEBPACK_IMPORTED_MODULE_1_jquery___default()('body').toggleClass('sidebar-collapse');
    },
    isQooco: function isQooco() {
      return this.$auth.user().roles.indexOf('ROLE_QOOCO') !== -1;
    },
    hasPermission: function hasPermission(permission) {
      // console.log('this.$auth.user()---->')
      // console.log(this.$auth.user())
      return this.isQooco() && this.$auth.user().permissions.indexOf(permission) !== -1;
    },
    logout: function logout() {
      this.$auth.logout({
        makeRequest: true,
        success: function success() {
          console.log('success');
          location.reload();
        },
        error: function error() {
          console.log('error');
        }
      });
    },
    _setCustomers: function _setCustomers() {
      var _this3 = this;

      Object(__WEBPACK_IMPORTED_MODULE_3_api_condition__["b" /* loadCustomers */])().then(function (res) {
        res.forEach(function (_scoo) {
          _scoo.name = _scoo.name + (' [' + _scoo.id + ']');
        });
        var user = _this3.$auth.watch.data;
        if (user.orgType === 'all') {
          _this3.setCustomers(res);
        } else {
          var _schools = [];
          res.forEach(function (customer) {
            if (user.schools.includes(customer['id'])) {
              _schools.push(customer);
            }
          });
          _this3.setCustomers(_schools);
        }
      }, function (msg) {
        _this3.$message.error(msg);
      });
    },
    _setPickerOptions: function _setPickerOptions() {
      var pickerOptions = {
        disabledDate: function disabledDate(time) {
          return time.getTime() > Date.now();
        },

        firstDayOfWeek: 7,
        shortcuts: [{
          text: '最近一周',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick: function onClick(picker) {
            var end = new Date();
            var start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      };
      this.setPickerOptions(pickerOptions);
    },
    _setOrgTypes: function _setOrgTypes() {
      var orgTypes = [{ id: 'school', name: '学校' }, { id: 'hotel', name: '酒店' }, { id: 'club', name: '巧口语吧' }, { id: 'all', name: '全部' }];
      this.setOrgTypes(orgTypes);
    },
    _setOrgClasses: function _setOrgClasses() {
      var _this4 = this;

      var orgClasses = [];
      Object(__WEBPACK_IMPORTED_MODULE_3_api_condition__["d" /* loadOrgClasses */])().then(function (res) {
        var user = _this4.$auth.watch.data;
        if (user.orgType === 'all') {
          _this4.setOrgClasses(orgClasses);
        } else {
          res.forEach(function (school) {
            var classes = [];
            school.classes.forEach(function (clazz) {
              var _clazz = { value: clazz.classid, label: clazz.name };
              classes.push(_clazz);
            });
            var _school = { value: school.orgid, label: school.name, children: classes };
            orgClasses.push(_school);
          });
          _this4.setOrgClasses(orgClasses);
        }
      }, function (msg) {
        _this4.setOrgClasses([]);
        _this4.$message.error(msg);
      });
    },
    _setModeList: function _setModeList() {
      var _this5 = this;

      Object(__WEBPACK_IMPORTED_MODULE_3_api_condition__["c" /* loadModeList */])().then(function (res) {
        // console.log(objToKeyVal(res))
        _this5.setModeList(Object(__WEBPACK_IMPORTED_MODULE_2_common_js_common_utils__["d" /* objToKeyVal */])(res));
      });
    }
  }, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["c" /* mapMutations */])({
    setCustomers: 'SET_CUSTOMERS',
    setPickerOptions: 'SET_PICKER_OPTIONS',
    setOrgTypes: 'SET_ORG_TYPES',
    setOrgClasses: 'SET_ORG_CLASSES',
    setModeList: 'SET_MODE_LIST'
  }))
});

/***/ }),

/***/ "7Gw5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_details_clubweeks_vue__ = __webpack_require__("AFdJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5d359d27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_details_clubweeks_vue__ = __webpack_require__("bOaH");
function injectStyle (ssrContext) {
  __webpack_require__("9bhx")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5d359d27"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_details_clubweeks_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_5d359d27_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_details_clubweeks_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "85SI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("cUn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_learn_details__ = __webpack_require__("BM4Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__ = __webpack_require__("r/qW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_html2pdf_js__ = __webpack_require__("gZqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_html2pdf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_html2pdf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__("h3VH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import {Loading} from 'element-ui'

var _ = __webpack_require__("psq8"); // 深拷贝
var colors = ['rgb(91,155,213)', '#ef3e42'];

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['orgTypes', 'customers', 'pickerOptions'])),
  data: function data() {
    return {
      modCustomers: [],
      canPrint: false,
      printingPDF: false,
      dateRange: [],
      currentDate: new Date(),
      filters: {
        customer: [],
        dateRange: [],
        orgType: '',
        featureId: '6',
        cardType: 'all'
      },

      loading: true,

      attendanceDistribute: {},
      learnDurationDistribute: {},
      starDistribute: {},
      qoocoShowDistribute: {}
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full__["a" /* default */]
  },
  created: function created() {
    var _this2 = this;

    [{ k: 'attendance', v: '线上出勤（天）', type: 'bar' }, { k: 'learnDuration', v: '线上平均学习时长(分钟)', type: 'bar' }, { k: 'star', v: '星星数量（颗）', type: 'bar' }, { k: 'qoocoShow', v: '巧口秀视频数量（个）', type: 'bar' }].forEach(function (obj) {
      // 创建柱形图------------------------------------------
      _this2[obj.k + 'Distribute'] = {
        title: {
          text: obj.v + '\u5206\u5E03',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          formatter: function formatter(param) {
            var o = param[0];
            var t = param[1];
            return o.axisValue + '<br/>' + (o.marker + o.seriesName) + ': ' + o.data + '<br/>\n            ' + (t.marker + t.seriesName) + ': ' + Number(t.data * 100).toFixed(0) + '%';
          },
          axisPointer: {
            type: 'cross'
          }
        },
        grid: { x: '15%', y: '14%', width: '70%', height: '70%' },
        legend: {
          data: ['\u4EBA\u6570', '\u5360\u6BD4'],
          bottom: 5
        },
        xAxis: {
          data: []
        },
        yAxis: [{
          type: 'value',
          name: '\u4EBA\u6570',
          min: 0,
          position: 'left',
          axisLine: {
            lineStyle: {
              color: colors[0]
            }
          },
          axisLabel: {
            formatter: '{value} 人'
          }
        }, {
          type: 'value',
          name: '\u5360\u6BD4',
          min: 0,
          max: 1,
          position: 'right',
          axisLine: {
            lineStyle: {
              color: colors[1]
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: '\u4EBA\u6570',
          type: 'bar',
          data: []
        }, {
          name: '\u5360\u6BD4',
          type: 'line',
          showAllSymbol: true,
          yAxisIndex: 1,
          data: [],
          label: {
            normal: {
              show: true,
              position: 'top',
              color: 'black',
              formatter: function formatter(params) {
                return Number(params.value * 100).toFixed(0) + '%';
              }
            }
          }
        }],
        color: colors
      };
    });
  },
  mounted: function mounted() {
    this.chOrgType();
    this.query();
  },

  methods: {
    query: function query() {
      this._showDateRange(this._loadQoocobarStatistics);
    },
    _showDateRange: function _showDateRange(callback) {
      var t = _.cloneDeep(this.filters.dateRange);
      console.log(t);
      if (t && t.length === 2) {
        this.dateRange = t;
        callback();
      } else {
        this.dateRange = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["d" /* getLastWeek */])();
        callback();
      }
    },
    _loadQoocobarStatistics: function _loadQoocobarStatistics() {
      var _this3 = this;

      this.canPrint = false;
      this.loading = true;
      var dateRange = this.dateRange;
      console.log(dateRange);
      var m0 = __WEBPACK_IMPORTED_MODULE_7_moment___default()(dateRange[0], 'YYYY-MM-DD');
      var m1 = __WEBPACK_IMPORTED_MODULE_7_moment___default()(dateRange[1], 'YYYY-MM-DD');
      var mMax = __WEBPACK_IMPORTED_MODULE_7_moment___default()(m0).add(7, 'days');
      var isIn7day = m1.format('YYYYMMDD') < mMax.format('YYYYMMDD');
      if (isIn7day) {
        // 一周以内的时间段
        Object(__WEBPACK_IMPORTED_MODULE_4_api_learn_details__["c" /* loadQoocobarStatistics */])(this.filters).then(function (res) {
          _this3.canPrint = true;
          _this3.loading = false;
          var maxNumFeatured = res.maxNum;
          var maxNumAll = res.maxNum2;
          ['attendance', 'learnDuration', 'star', 'qoocoShow'].forEach(function (item) {
            var maxNum = item === 'qoocoShow' ? maxNumAll : maxNumFeatured;
            // 填充柱状图（比例）
            var distributionKV = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["e" /* parseTwoArray */])(res[item], _this3._getDistributeMap(item));
            _this3[item + 'Distribute'].yAxis[0].max = maxNum; // 总用户数
            _this3[item + 'Distribute'].xAxis.data = distributionKV.keys;
            _this3[item + 'Distribute'].series[0].data = distributionKV.values;
            // 占比
            var rates = [];
            distributionKV.values.forEach(function (t) {
              return rates.push(t / maxNum);
            });
            _this3[item + 'Distribute'].series[1].data = rates;
          });
        }, function (msg) {
          _this3.canPrint = false;
          _this3.loading = false;
          _this3._resetData();
          _this3.$message.error(msg);
        });
      } else {
        this.canPrint = false;
        this.loading = false;
        this._resetData();
        this.$message.error('\u8BF7\u9009\u62E9\u4E00\u5468\u4EE5\u5185\u7684\u65F6\u95F4\u6BB5\uFF01');
      }
    },
    _getDistributeMap: function _getDistributeMap(item) {
      var map = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      switch (item) {
        case 'attendance':
          map.set('day0', '0');
          map.set('day1', '1');
          map.set('day2', '2');
          map.set('day3', '3');
          map.set('day4', '4');
          map.set('day5', '5');
          map.set('day6', '6');
          map.set('day7', '7        天');
          break;
        case 'learnDuration':
          map.set('min_10', '<10');
          map.set('min10_15', '10~15');
          map.set('min16_20', '15~20');
          map.set('min21_30', '20~30');
          map.set('min31_50', '30~50');
          map.set('min51_70', '50~75');
          map.set('min71_', '≥75        分钟');
          break;
        case 'star':
          map.set('star_15', '0-15');
          map.set('star16_30', '16~30');
          map.set('star31_45', '31~45');
          map.set('star46_60', '46~60');
          map.set('star61_75', '61~75');
          map.set('star_others', '其他        颗');
          break;
        case 'qoocoShow':
          map.set('show0', '0');
          map.set('show1', '1');
          map.set('show2', '2');
          map.set('show_others', '其他        个');
          break;
      }
      return map;
    },
    chOrgType: function chOrgType() {
      var _this4 = this;

      if (this.filters.orgType === '' || this.filters.orgType === 'all') {
        this.modCustomers = this.customers;
      } else {
        this.filters.customer = [];
        this.modCustomers = this.customers.filter(function (t) {
          return t.type === _this4.filters.orgType;
        });
      }
    },
    _resetData: function _resetData() {
      var _this5 = this;

      ['attendance', 'learnDuration', 'star', 'qoocoShow'].forEach(function (item) {
        // 清空柱状图（比例）
        _this5[item + 'Distribute'].xAxis.data = [];
        _this5[item + 'Distribute'].series[0].data = [];
        _this5[item + 'Distribute'].series[1].data = [];
      });
    },
    genPdf: function genPdf() {
      var _this = this;
      var customer = _this.customers.filter(function (t) {
        return t.id === _this.filters.customer;
      })[0];
      var filename = customer.name + '(' + this.dateRange[0] + '~' + this.dateRange[1] + ').pdf';
      var dom2Print = document.querySelector('.content');
      var originWidth = dom2Print.style.width;
      dom2Print.style.width = '800px';
      this.printingPDF = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_6_html2pdf_js___default()().from(dom2Print).save(filename).then(function () {
          dom2Print.style.width = originWidth;
          _this.printingPDF = false;
        });
      }, 1000);
    }
  }
});

/***/ }),

/***/ "9bhx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9h+P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_details_vue__ = __webpack_require__("LBR7");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_686ec9bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_details_vue__ = __webpack_require__("U/dz");
function injectStyle (ssrContext) {
  __webpack_require__("uMAF")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-686ec9bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_686ec9bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9h6Z":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9reN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_card_course_search__ = __webpack_require__("pcz7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // condition
      userName: '',
      // dialog
      dialogTableVisible: false,
      // errorMsg
      msg: '',
      // pagination
      page: 1,
      total: 0,
      pageSize: 10,
      // business
      courseList: [],
      user_name: '',
      nick_name: '',
      orderHiList: []
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_0_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.query();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.query();
    },
    query: function query() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1_api_card_course_search__["b" /* checkPkg */])({ userName: this.userName }).then(function (res) {
        _this.courseList = res.valid_packages; // this.parsePkg(res)
        _this.user_name = res.user_name;
        _this.nick_name = res.nick_name;
        _this.msg = '';
      }).catch(function (msg) {
        _this.courseList = [];
        _this.user_name = '';
        _this.nick_name = '';
        _this.msg = msg;
      });
    },
    parsePkg: function parsePkg(res) {
      var arr = [];
      res.valid_packages.forEach(function (t, index) {
        var obj = {};
        if (index === 0) {
          obj.multiFirst = true;
          obj.multiTotal = res.valid_packages.length;
        }
        obj.user_name = res.user_name;
        obj.nick_name = res.nick_name;
        obj.user_id = t.user_id;
        obj.package_name = t.package_name;
        obj.valid_days = t.valid_days;
        obj.active_date = t.active_date;
        obj.exp_date = t.exp_date;
        obj.package_id = t.package_id;
        arr.push(obj);
      });
      return arr;
    },
    pkgHistory: function pkgHistory(row) {
      var _this2 = this;

      // alert(row.user_id + '-' + row.package_id)
      Object(__WEBPACK_IMPORTED_MODULE_1_api_card_course_search__["c" /* checkPkgHistory */])(row.user_id, row.package_id).then(function (res) {
        _this2.orderHiList = res.order_history;
        _this2.dialogTableVisible = true;
      }).catch(function (msg) {
        _this2.$message.error(msg);
      });
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;
      // :span-method="objectSpanMethod"
      if (columnIndex in [0, 1]) {
        if (row.multiFirst) {
          return {
            rowspan: row.multiTotal,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    }
  }
});

/***/ }),

/***/ "AFdJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_learn_details__ = __webpack_require__("BM4Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__ = __webpack_require__("r/qW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2pdf_js__ = __webpack_require__("gZqQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_html2pdf_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_html2pdf_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__("h3VH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import {Loading} from 'element-ui'

var _ = __webpack_require__("psq8"); // 深拷贝
var colors = ['rgb(91,155,213)', '#ef3e42'];

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['orgTypes', 'customers', 'pickerOptions'])),
  data: function data() {
    return {
      modCustomers: [],
      canPrint: false,
      printingPDF: false,
      dateRange: [],
      currentDate: new Date(),
      filters: {
        customer: [],
        dateRange: [],
        orgType: '',
        featureId: '6',
        cardType: 'all'
      },

      loading: true,

      attendance: {},
      learnDuration: {},
      star: {},
      qoocoshow: {}
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_1_vue_echarts_v3_src_full__["a" /* default */]
  },
  created: function created() {
    var _this2 = this;

    [{ k: 'attendance', v: '线上出勤', type: 'bar' }, { k: 'learnDuration', v: '线上学习时长', type: 'bar' }, { k: 'star', v: '星星数量', type: 'bar' }, { k: 'qoocoshow', v: '巧口秀视频数量', type: 'bar' }].forEach(function (obj) {
      // 创建柱形图------------------------------------------
      _this2[obj.k] = {
        title: {
          text: '' + obj.v,
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          confine: true,
          formatter: function formatter(param) {
            var o = param[0];
            var t = param[1];
            var u = param[2];
            return o.axisValue + '<br/>\n            ' + (o.marker + o.seriesName) + ': ' + o.data + '<br/>\n            ' + (t.marker + t.seriesName) + ': ' + t.data + '<br/>\n            ' + (u.marker + u.seriesName) + ': ' + Number(u.data * 100).toFixed(0) + '%';
          },
          axisPointer: {
            type: 'cross'
          }
        },
        grid: { x: '15%', y: '14%', width: '70%', height: '70%' },
        legend: {
          data: ['\u5408\u683C\u4EBA\u6570', '\u603B\u7528\u6237\u6570', '\u5360\u6BD4'],
          bottom: 5
        },
        xAxis: {
          data: []
        },
        yAxis: [{
          type: 'value',
          name: '\u4EBA\u6570',
          min: 0,
          position: 'left',
          axisLine: {
            lineStyle: {
              color: colors[0]
            }
          },
          axisLabel: {
            formatter: '{value} 人'
          }
        }, {
          type: 'value',
          name: '\u5360\u6BD4',
          min: 0,
          max: 1,
          position: 'right',
          axisLine: {
            lineStyle: {
              color: colors[1]
            }
          },
          axisLabel: {
            formatter: '{value}'
          }
        }],
        series: [{
          name: '\u5408\u683C\u4EBA\u6570',
          type: 'bar',
          showAllSymbol: true,
          data: [],
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          }
        }, {
          name: '\u603B\u7528\u6237\u6570',
          type: 'bar',
          showAllSymbol: true,
          data: [],
          label: {
            normal: {
              show: true,
              position: 'top'
            }
          }
        }, {
          name: '\u5360\u6BD4',
          type: 'line',
          showAllSymbol: true,
          yAxisIndex: 1,
          data: [],
          label: {
            normal: {
              show: true,
              position: 'top',
              color: 'black',
              formatter: function formatter(params) {
                return Number(params.value * 100).toFixed(0) + '%';
              }
            }
          }
        }],
        color: colors
      };
    });
  },
  mounted: function mounted() {
    this.chOrgType();
    this.query();
  },

  methods: {
    query: function query() {
      this._showDateRange(this._loadClubWeeks);
    },
    _showDateRange: function _showDateRange(callback) {
      var t = _.cloneDeep(this.filters.dateRange);
      console.log(t);
      if (t && t.length === 2) {
        this.dateRange = t;
        callback();
      } else {
        this.dateRange = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["d" /* getLastWeek */])();
        callback();
      }
    },
    _loadClubWeeks: function _loadClubWeeks() {
      var _this3 = this;

      this.canPrint = false;
      this.loading = true;
      var dateRange = this.dateRange;
      console.log(dateRange);
      var m0 = __WEBPACK_IMPORTED_MODULE_6_moment___default()(dateRange[0], 'YYYY-MM-DD');
      var m1 = __WEBPACK_IMPORTED_MODULE_6_moment___default()(dateRange[1], 'YYYY-MM-DD');
      var mMax = __WEBPACK_IMPORTED_MODULE_6_moment___default()(m0).add(7 * 5, 'days');
      var isIn7day = m1.format('YYYYMMDD') < mMax.format('YYYYMMDD');
      if (isIn7day) {
        // 一周以内的时间段
        Object(__WEBPACK_IMPORTED_MODULE_3_api_learn_details__["a" /* loadClubWeeks */])(this.filters).then(function (res) {
          console.log(res);
          _this3.canPrint = true;
          _this3.loading = false;['attendance', 'learnDuration', 'star', 'qoocoshow'].forEach(function (item) {
            // 填充柱状图（比例）
            console.log(res[item]);
            var arrs = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["b" /* extractArrsFromObj */])(res[item], ['week', 'total', 'num', 'rate']);
            console.log(arrs);
            _this3['' + item].yAxis[0].max = Math.max.apply(null, arrs.total); // 总用户数
            _this3['' + item].xAxis.data = arrs.week.reverse();
            _this3['' + item].series[0].data = arrs.num.reverse();
            _this3['' + item].series[1].data = arrs.total.reverse();
            // 占比
            _this3['' + item].series[2].data = arrs.rate.reverse();
          });
        }, function (msg) {
          _this3.canPrint = false;
          _this3.loading = false;
          _this3._resetData();
          _this3.$message.error(msg);
        });
      } else {
        this.canPrint = false;
        this.loading = false;
        this._resetData();
        this.$message.error('\u8BF7\u9009\u62E95\u5468\u4EE5\u5185\u7684\u65F6\u95F4\u6BB5\uFF01');
      }
    },
    chOrgType: function chOrgType() {
      var _this4 = this;

      if (this.filters.orgType === '' || this.filters.orgType === 'all') {
        this.modCustomers = this.customers;
      } else {
        this.filters.customer = '';
        this.modCustomers = this.customers.filter(function (t) {
          return t.type === _this4.filters.orgType;
        });
      }
    },
    _resetData: function _resetData() {
      var _this5 = this;

      ['attendance', 'learnDuration', 'star', 'qoocoshow'].forEach(function (item) {
        // 清空柱状图（比例）
        _this5['' + item].xAxis.data = [];
        _this5['' + item].series[0].data = [];
        _this5['' + item].series[1].data = [];
      });
    },
    genPdf: function genPdf() {
      var _this = this;
      var customer = _this.customers.filter(function (t) {
        return t.id === _this.filters.customer;
      })[0];
      var filename = customer.name + '(' + _this.dateRange[0] + '~' + _this.dateRange[1] + ').pdf';
      var dom2Print = document.querySelector('.content');
      var originWidth = dom2Print.style.width;
      dom2Print.style.width = '800px';
      this.printingPDF = true;
      setTimeout(function () {
        __WEBPACK_IMPORTED_MODULE_5_html2pdf_js___default()().from(dom2Print).save(filename).then(function () {
          dom2Print.style.width = originWidth;
          _this.printingPDF = false;
        });
      }, 1000);
    }
  }
});

/***/ }),

/***/ "ASCY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7ec3456e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_err_502_vue__ = __webpack_require__("U1yt");
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7ec3456e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_err_502_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "B0rx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadPackagesOrders; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("Dod7");

// tab1 运营详情数据
var loadPackagesOrders = function loadPackagesOrders(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('operateDetails/packagesOrders', params).then(function (res) {
    return res;
  });
};

/***/ }),

/***/ "BKMg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BM4Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadLearnDetails; });
/* unused harmony export loadSchoolStatistics */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadQoocobarStatistics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadClubWeeks; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("Dod7");

// tab1 运营详情数据
var loadLearnDetails = function loadLearnDetails(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('learnDetails/learnDetails', params).then(function (res) {
    return res;
  });
};
var loadSchoolStatistics = function loadSchoolStatistics(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('learnDetails/schoolStatistics', params).then(function (res) {
    return res;
  });
};
var loadQoocobarStatistics = function loadQoocobarStatistics(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('learnDetails/qoocobarStatistics', params).then(function (res) {
    return res;
  });
};
var loadClubWeeks = function loadClubWeeks(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('learnDetails/listComparedClubData', params).then(function (res) {
    return res;
  });
};

/***/ }),

/***/ "Bx0M":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_common_js_app_utils__ = __webpack_require__("r/qW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery__ = __webpack_require__("fu2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jquery__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { requestLogin } from 'api/api'
// import NProgress from 'nprogress'


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      fromClub: 'true',
      msg: '',
      logining: false,
      ruleForm2: {
        username: '',
        password: ''
      },
      rules2: {
        username: [{ required: true, message: '请输入账号', trigger: 'blur'
          // { validator: validaePass }
        }],
        password: [{ required: true, message: '请输入密码', trigger: 'blur'
          // { validator: validaePass2 }
        }]
      },
      checked: true
    };
  },
  created: function created() {
    this.fromClub = Object(__WEBPACK_IMPORTED_MODULE_0_common_js_app_utils__["c" /* fromClub */])();
  },
  mounted: function mounted() {
    var _this = this;

    if (Object(__WEBPACK_IMPORTED_MODULE_0_common_js_app_utils__["c" /* fromClub */])()) {
      // 来自语吧，自动登录
      var loading = this.$loading({
        lock: true,
        text: '请稍等...',
        spinner: 'el-icon-loading',
        background: 'rgba(245, 245, 245, 1)'
      });
      __WEBPACK_IMPORTED_MODULE_1_jquery___default.a.getScript('https://club.qooco.com/das/sessionId', function () {
        if (window.sessionId) {
          setTimeout(function () {
            return loading.close();
          }, 700);
          _this.autoLoginWithClubSessionId();
          localStorage.setItem('lastClubSessionId', window.sessionId);
        } else {
          loading.text = '请重新登录club.qooco.com';
        }
      });
    }
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          var loading = _this2.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          var redirect = _this2.$auth.redirect();
          // debugger
          _this2.$auth.login({
            body: _this2.ruleForm2, // Vue-resource
            rememberMe: _this2.checked,
            redirect: { name: redirect ? redirect.from.name : 'default' },
            fetchUser: true,
            success: function success() {
              loading.close();
            },
            error: function error(res) {
              loading.close();
              console.log('error1');
              console.log(res);
              this.msg = res.data.msg;
            }
          });
        } else {
          _this2.msg = '请正确输入用户名和密码';
          return false;
        }
      });
    },
    autoLoginWithClubSessionId: function autoLoginWithClubSessionId() {
      this.ruleForm2.username = 'loginWithClub';
      this.ruleForm2.password = window.sessionId;

      var redirect = this.$auth.redirect();
      var loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(245, 245, 245, 1)'
      });
      this.$auth.login({
        body: this.ruleForm2, // Vue-resource
        rememberMe: this.checked,
        redirect: { name: redirect ? redirect.from.name : 'default' },
        fetchUser: true,
        success: function success() {
          loading.close();
        },
        error: function error(res) {
          loading.close();
          console.log(res);
          this.$loading({
            lock: true,
            text: res.data.msg + '--请关闭窗口5分钟后重试或联系管理员',
            spinner: 'el-icon-loading',
            background: 'rgba(245, 245, 245, 1)'
          });
        }
      });
    }
  }
});

/***/ }),

/***/ "Bx7T":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(jQuery) {/*! AdminLTE app.js
* ================
* Main JS application file for AdminLTE v2. This file
* should be included in all pages. It controls some layout
* options and implements exclusive AdminLTE plugins.
*
* @Author  Almsaeed Studio
* @Support <https://www.almsaeedstudio.com>
* @Email   <abdullah@almsaeedstudio.com>
* @version 2.4.0
* @repository git://github.com/almasaeed2010/AdminLTE.git
* @license MIT <http://opensource.org/licenses/MIT>
*/

// Make sure jQuery has been loaded
if (typeof jQuery === 'undefined') {
throw new Error('AdminLTE requires jQuery')
}

/* BoxRefresh()
 * =========
 * Adds AJAX content control to a box.
 *
 * @Usage: $('#my-box').boxRefresh(options)
 *         or add [data-widget="box-refresh"] to the box element
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.boxrefresh'

  var Default = {
    source         : '',
    params         : {},
    trigger        : '.refresh-btn',
    content        : '.box-body',
    loadInContent  : true,
    responseType   : '',
    overlayTemplate: '<div class="overlay"><div class="fa fa-refresh fa-spin"></div></div>',
    onLoadStart    : function () {
    },
    onLoadDone     : function (response) {
      return response
    }
  }

  var Selector = {
    data: '[data-widget="box-refresh"]'
  }

  // BoxRefresh Class Definition
  // =========================
  var BoxRefresh = function (element, options) {
    this.element  = element
    this.options  = options
    this.$overlay = $(options.overlay)

    if (options.source === '') {
      throw new Error('Source url was not defined. Please specify a url in your BoxRefresh source option.')
    }

    this._setUpListeners()
    this.load()
  }

  BoxRefresh.prototype.load = function () {
    this._addOverlay()
    this.options.onLoadStart.call($(this))

    $.get(this.options.source, this.options.params, function (response) {
      if (this.options.loadInContent) {
        $(this.options.content).html(response)
      }
      this.options.onLoadDone.call($(this), response)
      this._removeOverlay()
    }.bind(this), this.options.responseType !== '' && this.options.responseType)
  }

  // Private

  BoxRefresh.prototype._setUpListeners = function () {
    $(this.element).on('click', Selector.trigger, function (event) {
      if (event) event.preventDefault()
      this.load()
    }.bind(this))
  }

  BoxRefresh.prototype._addOverlay = function () {
    $(this.element).append(this.$overlay)
  }

  BoxRefresh.prototype._removeOverlay = function () {
    $(this.element).remove(this.$overlay)
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new BoxRefresh($this, options)))
      }

      if (typeof data == 'string') {
        if (typeof data[option] == 'undefined') {
          throw new Error('No method named ' + option)
        }
        data[option]()
      }
    })
  }

  var old = $.fn.boxRefresh

  $.fn.boxRefresh             = Plugin
  $.fn.boxRefresh.Constructor = BoxRefresh

  // No Conflict Mode
  // ================
  $.fn.boxRefresh.noConflict = function () {
    $.fn.boxRefresh = old
    return this
  }

  // BoxRefresh Data API
  // =================
  $(window).on('load', function () {
    $(Selector.data).each(function () {
      Plugin.call($(this))
    })
  })

}(jQuery)


/* BoxWidget()
 * ======
 * Adds box widget functions to boxes.
 *
 * @Usage: $('.my-box').boxWidget(options)
 *         This plugin auto activates on any element using the `.box` class
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.boxwidget'

  var Default = {
    animationSpeed : 500,
    collapseTrigger: '[data-widget="collapse"]',
    removeTrigger  : '[data-widget="remove"]',
    collapseIcon   : 'fa-minus',
    expandIcon     : 'fa-plus',
    removeIcon     : 'fa-times'
  }

  var Selector = {
    data     : '.box',
    collapsed: '.collapsed-box',
    body     : '.box-body',
    footer   : '.box-footer',
    tools    : '.box-tools'
  }

  var ClassName = {
    collapsed: 'collapsed-box'
  }

  var Event = {
    collapsed: 'collapsed.boxwidget',
    expanded : 'expanded.boxwidget',
    removed  : 'removed.boxwidget'
  }

  // BoxWidget Class Definition
  // =====================
  var BoxWidget = function (element, options) {
    this.element = element
    this.options = options

    this._setUpListeners()
  }

  BoxWidget.prototype.toggle = function () {
    var isOpen = !$(this.element).is(Selector.collapsed)

    if (isOpen) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  BoxWidget.prototype.expand = function () {
    var expandedEvent = $.Event(Event.expanded)
    var collapseIcon  = this.options.collapseIcon
    var expandIcon    = this.options.expandIcon

    $(this.element).removeClass(ClassName.collapsed)

    $(this.element)
      .find(Selector.tools)
      .find('.' + expandIcon)
      .removeClass(expandIcon)
      .addClass(collapseIcon)

    $(this.element).find(Selector.body + ', ' + Selector.footer)
      .slideDown(this.options.animationSpeed, function () {
        $(this.element).trigger(expandedEvent)
      }.bind(this))
  }

  BoxWidget.prototype.collapse = function () {
    var collapsedEvent = $.Event(Event.collapsed)
    var collapseIcon   = this.options.collapseIcon
    var expandIcon     = this.options.expandIcon

    $(this.element)
      .find(Selector.tools)
      .find('.' + collapseIcon)
      .removeClass(collapseIcon)
      .addClass(expandIcon)

    $(this.element).find(Selector.body + ', ' + Selector.footer)
      .slideUp(this.options.animationSpeed, function () {
        $(this.element).addClass(ClassName.collapsed)
        $(this.element).trigger(collapsedEvent)
      }.bind(this))
  }

  BoxWidget.prototype.remove = function () {
    var removedEvent = $.Event(Event.removed)

    $(this.element).slideUp(this.options.animationSpeed, function () {
      $(this.element).trigger(removedEvent)
      $(this.element).remove()
    }.bind(this))
  }

  // Private

  BoxWidget.prototype._setUpListeners = function () {
    var that = this

    $(this.element).on('click', this.options.collapseTrigger, function (event) {
      if (event) event.preventDefault()
      that.toggle()
    })

    $(this.element).on('click', this.options.removeTrigger, function (event) {
      if (event) event.preventDefault()
      that.remove()
    })
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new BoxWidget($this, options)))
      }

      if (typeof option == 'string') {
        if (typeof data[option] == 'undefined') {
          throw new Error('No method named ' + option)
        }
        data[option]()
      }
    })
  }

  var old = $.fn.boxWidget

  $.fn.boxWidget             = Plugin
  $.fn.boxWidget.Constructor = BoxWidget

  // No Conflict Mode
  // ================
  $.fn.boxWidget.noConflict = function () {
    $.fn.boxWidget = old
    return this
  }

  // BoxWidget Data API
  // ==================
  $(window).on('load', function () {
    $(Selector.data).each(function () {
      Plugin.call($(this))
    })
  })

}(jQuery)


/* ControlSidebar()
 * ===============
 * Toggles the state of the control sidebar
 *
 * @Usage: $('#control-sidebar-trigger').controlSidebar(options)
 *         or add [data-toggle="control-sidebar"] to the trigger
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.controlsidebar'

  var Default = {
    slide: true
  }

  var Selector = {
    sidebar: '.control-sidebar',
    data   : '[data-toggle="control-sidebar"]',
    open   : '.control-sidebar-open',
    bg     : '.control-sidebar-bg',
    wrapper: '.wrapper',
    content: '.content-wrapper',
    boxed  : '.layout-boxed'
  }

  var ClassName = {
    open : 'control-sidebar-open',
    fixed: 'fixed'
  }

  var Event = {
    collapsed: 'collapsed.controlsidebar',
    expanded : 'expanded.controlsidebar'
  }

  // ControlSidebar Class Definition
  // ===============================
  var ControlSidebar = function (element, options) {
    this.element         = element
    this.options         = options
    this.hasBindedResize = false

    this.init()
  }

  ControlSidebar.prototype.init = function () {
    // Add click listener if the element hasn't been
    // initialized using the data API
    if (!$(this.element).is(Selector.data)) {
      $(this).on('click', this.toggle)
    }

    this.fix()
    $(window).resize(function () {
      this.fix()
    }.bind(this))
  }

  ControlSidebar.prototype.toggle = function (event) {
    if (event) event.preventDefault()

    this.fix()

    if (!$(Selector.sidebar).is(Selector.open) && !$('body').is(Selector.open)) {
      this.expand()
    } else {
      this.collapse()
    }
  }

  ControlSidebar.prototype.expand = function () {
    if (!this.options.slide) {
      $('body').addClass(ClassName.open)
    } else {
      $(Selector.sidebar).addClass(ClassName.open)
    }

    $(this.element).trigger($.Event(Event.expanded))
  }

  ControlSidebar.prototype.collapse = function () {
    $('body, ' + Selector.sidebar).removeClass(ClassName.open)
    $(this.element).trigger($.Event(Event.collapsed))
  }

  ControlSidebar.prototype.fix = function () {
    if ($('body').is(Selector.boxed)) {
      this._fixForBoxed($(Selector.bg))
    }
  }

  // Private

  ControlSidebar.prototype._fixForBoxed = function (bg) {
    bg.css({
      position: 'absolute',
      height  : $(Selector.wrapper).height()
    })
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new ControlSidebar($this, options)))
      }

      if (typeof option == 'string') data.toggle()
    })
  }

  var old = $.fn.controlSidebar

  $.fn.controlSidebar             = Plugin
  $.fn.controlSidebar.Constructor = ControlSidebar

  // No Conflict Mode
  // ================
  $.fn.controlSidebar.noConflict = function () {
    $.fn.controlSidebar = old
    return this
  }

  // ControlSidebar Data API
  // =======================
  $(document).on('click', Selector.data, function (event) {
    if (event) event.preventDefault()
    Plugin.call($(this), 'toggle')
  })

}(jQuery)


/* DirectChat()
 * ===============
 * Toggles the state of the control sidebar
 *
 * @Usage: $('#my-chat-box').directChat()
 *         or add [data-widget="direct-chat"] to the trigger
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.directchat'

  var Selector = {
    data: '[data-widget="chat-pane-toggle"]',
    box : '.direct-chat'
  }

  var ClassName = {
    open: 'direct-chat-contacts-open'
  }

  // DirectChat Class Definition
  // ===========================
  var DirectChat = function (element) {
    this.element = element
  }

  DirectChat.prototype.toggle = function ($trigger) {
    $trigger.parents(Selector.box).first().toggleClass(ClassName.open)
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        $this.data(DataKey, (data = new DirectChat($this)))
      }

      if (typeof option == 'string') data.toggle($this)
    })
  }

  var old = $.fn.directChat

  $.fn.directChat             = Plugin
  $.fn.directChat.Constructor = DirectChat

  // No Conflict Mode
  // ================
  $.fn.directChat.noConflict = function () {
    $.fn.directChat = old
    return this
  }

  // DirectChat Data API
  // ===================
  $(document).on('click', Selector.data, function (event) {
    if (event) event.preventDefault()
    Plugin.call($(this), 'toggle')
  })

}(jQuery)


/* Layout()
 * ========
 * Implements AdminLTE layout.
 * Fixes the layout height in case min-height fails.
 *
 * @usage activated automatically upon window load.
 *        Configure any options by passing data-option="value"
 *        to the body tag.
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.layout'

  var Default = {
    slimscroll : true,
    resetHeight: true
  }

  var Selector = {
    wrapper       : '.wrapper',
    contentWrapper: '.content-wrapper',
    layoutBoxed   : '.layout-boxed',
    mainFooter    : '.main-footer',
    mainHeader    : '.main-header',
    sidebar       : '.sidebar',
    controlSidebar: '.control-sidebar',
    fixed         : '.fixed',
    sidebarMenu   : '.sidebar-menu',
    logo          : '.main-header .logo'
  }

  var ClassName = {
    fixed         : 'fixed',
    holdTransition: 'hold-transition'
  }

  var Layout = function (options) {
    this.options      = options
    this.bindedResize = false
    this.activate()
  }

  Layout.prototype.activate = function () {
    this.fix()
    this.fixSidebar()

    $('body').removeClass(ClassName.holdTransition)

    if (this.options.resetHeight) {
      $('body, html, ' + Selector.wrapper).css({
        'height'    : 'auto',
        'min-height': '100%'
      })
    }

    if (!this.bindedResize) {
      $(window).resize(function () {
        this.fix()
        this.fixSidebar()

        $(Selector.logo + ', ' + Selector.sidebar).one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', function () {
          this.fix()
          this.fixSidebar()
        }.bind(this))
      }.bind(this))

      this.bindedResize = true
    }

    $(Selector.sidebarMenu).on('expanded.tree', function () {
      this.fix()
      this.fixSidebar()
    }.bind(this))

    $(Selector.sidebarMenu).on('collapsed.tree', function () {
      this.fix()
      this.fixSidebar()
    }.bind(this))
  }

  Layout.prototype.fix = function () {
    // Remove overflow from .wrapper if layout-boxed exists
    $(Selector.layoutBoxed + ' > ' + Selector.wrapper).css('overflow', 'hidden')

    // Get window height and the wrapper height
    var footerHeight  = $(Selector.mainFooter).outerHeight() || 0
    var neg           = $(Selector.mainHeader).outerHeight() + footerHeight
    var windowHeight  = $(window).height()
    var sidebarHeight = $(Selector.sidebar).height() || 0

    // Set the min-height of the content and sidebar based on
    // the height of the document.
    if ($('body').hasClass(ClassName.fixed)) {
      $(Selector.contentWrapper).css('min-height', windowHeight - footerHeight)
    } else {
      var postSetHeight

      if (windowHeight >= sidebarHeight) {
        $(Selector.contentWrapper).css('min-height', windowHeight - neg)
        postSetHeight = windowHeight - neg
      } else {
        $(Selector.contentWrapper).css('min-height', sidebarHeight)
        postSetHeight = sidebarHeight
      }

      // Fix for the control sidebar height
      var $controlSidebar = $(Selector.controlSidebar)
      if (typeof $controlSidebar !== 'undefined') {
        if ($controlSidebar.height() > postSetHeight)
          $(Selector.contentWrapper).css('min-height', $controlSidebar.height())
      }
    }
  }

  Layout.prototype.fixSidebar = function () {
    // Make sure the body tag has the .fixed class
    if (!$('body').hasClass(ClassName.fixed)) {
      if (typeof $.fn.slimScroll !== 'undefined') {
        $(Selector.sidebar).slimScroll({ destroy: true }).height('auto')
      }
      return
    }

    // Enable slimscroll for fixed layout
    if (this.options.slimscroll) {
      if (typeof $.fn.slimScroll !== 'undefined') {
        // Destroy if it exists
        // $(Selector.sidebar).slimScroll({ destroy: true }).height('auto')

        // Add slimscroll
        $(Selector.sidebar).slimScroll({
          height: ($(window).height() - $(Selector.mainHeader).height()) + 'px',
          color : 'rgba(0,0,0,0.2)',
          size  : '3px'
        })
      }
    }
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option === 'object' && option)
        $this.data(DataKey, (data = new Layout(options)))
      }

      if (typeof option === 'string') {
        if (typeof data[option] === 'undefined') {
          throw new Error('No method named ' + option)
        }
        data[option]()
      }
    })
  }

  var old = $.fn.layout

  $.fn.layout            = Plugin
  $.fn.layout.Constuctor = Layout

  // No conflict mode
  // ================
  $.fn.layout.noConflict = function () {
    $.fn.layout = old
    return this
  }

  // Layout DATA-API
  // ===============
  $(window).on('load', function () {
    Plugin.call($('body'))
  })
}(jQuery)


/* PushMenu()
 * ==========
 * Adds the push menu functionality to the sidebar.
 *
 * @usage: $('.btn').pushMenu(options)
 *          or add [data-toggle="push-menu"] to any button
 *          Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.pushmenu'

  var Default = {
    collapseScreenSize   : 767,
    expandOnHover        : false,
    expandTransitionDelay: 200
  }

  var Selector = {
    collapsed     : '.sidebar-collapse',
    open          : '.sidebar-open',
    mainSidebar   : '.main-sidebar',
    contentWrapper: '.content-wrapper',
    searchInput   : '.sidebar-form .form-control',
    button        : '[data-toggle="push-menu"]',
    mini          : '.sidebar-mini',
    expanded      : '.sidebar-expanded-on-hover',
    layoutFixed   : '.fixed'
  }

  var ClassName = {
    collapsed    : 'sidebar-collapse',
    open         : 'sidebar-open',
    mini         : 'sidebar-mini',
    expanded     : 'sidebar-expanded-on-hover',
    expandFeature: 'sidebar-mini-expand-feature',
    layoutFixed  : 'fixed'
  }

  var Event = {
    expanded : 'expanded.pushMenu',
    collapsed: 'collapsed.pushMenu'
  }

  // PushMenu Class Definition
  // =========================
  var PushMenu = function (options) {
    this.options = options
    this.init()
  }

  PushMenu.prototype.init = function () {
    if (this.options.expandOnHover
      || ($('body').is(Selector.mini + Selector.layoutFixed))) {
      this.expandOnHover()
      $('body').addClass(ClassName.expandFeature)
    }

    $(Selector.contentWrapper).click(function () {
      // Enable hide menu when clicking on the content-wrapper on small screens
      if ($(window).width() <= this.options.collapseScreenSize && $('body').hasClass(ClassName.open)) {
        this.close()
      }
    }.bind(this))

    // __Fix for android devices
    $(Selector.searchInput).click(function (e) {
      e.stopPropagation()
    })
  }

  PushMenu.prototype.toggle = function () {
    var windowWidth = $(window).width()
    var isOpen      = !$('body').hasClass(ClassName.collapsed)

    if (windowWidth <= this.options.collapseScreenSize) {
      isOpen = $('body').hasClass(ClassName.open)
    }

    if (!isOpen) {
      this.open()
    } else {
      this.close()
    }
  }

  PushMenu.prototype.open = function () {
    var windowWidth = $(window).width()

    if (windowWidth > this.options.collapseScreenSize) {
      $('body').removeClass(ClassName.collapsed)
        .trigger($.Event(Event.expanded))
    }
    else {
      $('body').addClass(ClassName.open)
        .trigger($.Event(Event.expanded))
    }
  }

  PushMenu.prototype.close = function () {
    var windowWidth = $(window).width()
    if (windowWidth > this.options.collapseScreenSize) {
      $('body').addClass(ClassName.collapsed)
        .trigger($.Event(Event.collapsed))
    } else {
      $('body').removeClass(ClassName.open + ' ' + ClassName.collapsed)
        .trigger($.Event(Event.collapsed))
    }
  }

  PushMenu.prototype.expandOnHover = function () {
    $(Selector.mainSidebar).hover(function () {
      if ($('body').is(Selector.mini + Selector.collapsed)
        && $(window).width() > this.options.collapseScreenSize) {
        this.expand()
      }
    }.bind(this), function () {
      if ($('body').is(Selector.expanded)) {
        this.collapse()
      }
    }.bind(this))
  }

  PushMenu.prototype.expand = function () {
    setTimeout(function () {
      $('body').removeClass(ClassName.collapsed)
        .addClass(ClassName.expanded)
    }, this.options.expandTransitionDelay)
  }

  PushMenu.prototype.collapse = function () {
    setTimeout(function () {
      $('body').removeClass(ClassName.expanded)
        .addClass(ClassName.collapsed)
    }, this.options.expandTransitionDelay)
  }

  // PushMenu Plugin Definition
  // ==========================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new PushMenu(options)))
      }

      if (option === 'toggle') data.toggle()
    })
  }

  var old = $.fn.pushMenu

  $.fn.pushMenu             = Plugin
  $.fn.pushMenu.Constructor = PushMenu

  // No Conflict Mode
  // ================
  $.fn.pushMenu.noConflict = function () {
    $.fn.pushMenu = old
    return this
  }

  // Data API
  // ========
  $(document).on('click', Selector.button, function (e) {
    e.preventDefault()
    Plugin.call($(this), 'toggle')
  })
  $(window).on('load', function () {
    Plugin.call($(Selector.button))
  })
}(jQuery)


/* TodoList()
 * =========
 * Converts a list into a todoList.
 *
 * @Usage: $('.my-list').todoList(options)
 *         or add [data-widget="todo-list"] to the ul element
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.todolist'

  var Default = {
    onCheck  : function (item) {
      return item
    },
    onUnCheck: function (item) {
      return item
    }
  }

  var Selector = {
    data: '[data-widget="todo-list"]'
  }

  var ClassName = {
    done: 'done'
  }

  // TodoList Class Definition
  // =========================
  var TodoList = function (element, options) {
    this.element = element
    this.options = options

    this._setUpListeners()
  }

  TodoList.prototype.toggle = function (item) {
    item.parents(Selector.li).first().toggleClass(ClassName.done)
    if (!item.prop('checked')) {
      this.unCheck(item)
      return
    }

    this.check(item)
  }

  TodoList.prototype.check = function (item) {
    this.options.onCheck.call(item)
  }

  TodoList.prototype.unCheck = function (item) {
    this.options.onUnCheck.call(item)
  }

  // Private

  TodoList.prototype._setUpListeners = function () {
    var that = this
    $(this.element).on('change ifChanged', 'input:checkbox', function () {
      that.toggle($(this))
    })
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, (data = new TodoList($this, options)))
      }

      if (typeof data == 'string') {
        if (typeof data[option] == 'undefined') {
          throw new Error('No method named ' + option)
        }
        data[option]()
      }
    })
  }

  var old = $.fn.todoList

  $.fn.todoList         = Plugin
  $.fn.todoList.Constructor = TodoList

  // No Conflict Mode
  // ================
  $.fn.todoList.noConflict = function () {
    $.fn.todoList = old
    return this
  }

  // TodoList Data API
  // =================
  $(window).on('load', function () {
    $(Selector.data).each(function () {
      Plugin.call($(this))
    })
  })

}(jQuery)


/* Tree()
 * ======
 * Converts a nested list into a multilevel
 * tree view menu.
 *
 * @Usage: $('.my-menu').tree(options)
 *         or add [data-widget="tree"] to the ul element
 *         Pass any option as data-option="value"
 */
+function ($) {
  'use strict'

  var DataKey = 'lte.tree'

  var Default = {
    animationSpeed: 500,
    accordion     : true,
    followLink    : false,
    trigger       : '.treeview a'
  }

  var Selector = {
    tree        : '.tree',
    treeview    : '.treeview',
    treeviewMenu: '.treeview-menu',
    open        : '.menu-open, .active',
    li          : 'li',
    data        : '[data-widget="tree"]',
    active      : '.active'
  }

  var ClassName = {
    open: 'menu-open',
    tree: 'tree'
  }

  var Event = {
    collapsed: 'collapsed.tree',
    expanded : 'expanded.tree'
  }

  // Tree Class Definition
  // =====================
  var Tree = function (element, options) {
    this.element = element
    this.options = options

    $(this.element).addClass(ClassName.tree)

    $(Selector.treeview + Selector.active, this.element).addClass(ClassName.open)

    this._setUpListeners()
  }

  Tree.prototype.toggle = function (link, event) {
    var treeviewMenu = link.next(Selector.treeviewMenu)
    var parentLi     = link.parent()
    var isOpen       = parentLi.hasClass(ClassName.open)

    if (!parentLi.is(Selector.treeview)) {
      return
    }

    if (!this.options.followLink || link.attr('href') === '#') {
      event.preventDefault()
    }

    if (isOpen) {
      this.collapse(treeviewMenu, parentLi)
    } else {
      this.expand(treeviewMenu, parentLi)
    }
  }

  Tree.prototype.expand = function (tree, parent) {
    var expandedEvent = $.Event(Event.expanded)

    if (this.options.accordion) {
      var openMenuLi = parent.siblings(Selector.open)
      var openTree   = openMenuLi.children(Selector.treeviewMenu)
      this.collapse(openTree, openMenuLi)
    }

    parent.addClass(ClassName.open)
    tree.slideDown(this.options.animationSpeed, function () {
      $(this.element).trigger(expandedEvent)
    }.bind(this))
  }

  Tree.prototype.collapse = function (tree, parentLi) {
    var collapsedEvent = $.Event(Event.collapsed)

    tree.find(Selector.open).removeClass(ClassName.open)
    parentLi.removeClass(ClassName.open)
    tree.slideUp(this.options.animationSpeed, function () {
      tree.find(Selector.open + ' > ' + Selector.treeview).slideUp()
      $(this.element).trigger(collapsedEvent)
    }.bind(this))
  }

  // Private

  Tree.prototype._setUpListeners = function () {
    var that = this

    $(this.element).on('click', this.options.trigger, function (event) {
      that.toggle($(this), event)
    })
  }

  // Plugin Definition
  // =================
  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data(DataKey)

      if (!data) {
        var options = $.extend({}, Default, $this.data(), typeof option == 'object' && option)
        $this.data(DataKey, new Tree($this, options))
      }
    })
  }

  var old = $.fn.tree

  $.fn.tree             = Plugin
  $.fn.tree.Constructor = Tree

  // No Conflict Mode
  // ================
  $.fn.tree.noConflict = function () {
    $.fn.tree = old
    return this
  }

  // Tree Data API
  // =============
  $(window).on('load', function () {
    $(Selector.data).each(function () {
      Plugin.call($(this))
    })
  })

  window['AdminLTE'] = function () {
    $(Selector.data).each(function () {
      Plugin.call($(this))
    })
  }
}(jQuery)

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("fu2u")))

/***/ }),

/***/ "BzwW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n    This is an Err403 page.\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CWX2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true}},[_c('el-form-item',[_c('el-input',{attrs:{"placeholder":"请输入要查询的用户名","clearable":""},model:{value:(_vm.userName),callback:function ($$v) {_vm.userName=$$v},expression:"userName"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('el-dialog',{attrs:{"width":"80%","title":"历史订单","visible":_vm.dialogTableVisible},on:{"update:visible":function($event){_vm.dialogTableVisible=$event}}},[_c('el-table',{attrs:{"data":_vm.orderHiList}},[_c('el-table-column',{attrs:{"property":"order_id","label":"订单号"}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"order_date","label":"购买时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"valid_days","label":"有效天数"}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"voipNum","label":"外教课次数"}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"card_number","label":"使用卡号"}}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"card_org","label":"充卡orgId"}})],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("查询结果")]),_vm._v(" "),_c('span',{staticStyle:{"margin-left":"10px","color":"red"}},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(_vm.user_name),expression:"user_name"}],attrs:{"type":"danger","effect":"plain"}},[_vm._v("用户名："+_vm._s(_vm.user_name))]),_vm._v(" "),_c('el-tag',{directives:[{name:"show",rawName:"v-show",value:(_vm.nick_name),expression:"nick_name"}],attrs:{"type":"success","effect":"plain"}},[_vm._v("昵称："+_vm._s(_vm.nick_name))])],1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.courseList,"border":""}},[_c('el-table-column',{attrs:{"prop":"package_id","label":"课程ID"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('el-tooltip',{attrs:{"content":"历史订单","placement":"top"}},[_c('el-button',{attrs:{"type":"text"},on:{"click":function($event){return _vm.pkgHistory(scope.row)}}},[_c('el-tag',{attrs:{"type":"danger"}},[_vm._v(_vm._s(scope.row.package_id))]),_vm._v("\n                    查看历史订单\n                ")],1)],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"package_name","label":"课程名"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valid_days","label":"有效天数"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"active_date","label":"课程开始时间"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"exp_date","label":"课程到期时间"}})],1)],1)],1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      用户卡密及课程查询\n      "),_c('small',[_vm._v("快速查询工具")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/operateDetails/operateDetails"}},[_vm._v("快速查询工具")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("用户卡密及课程查询")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CrP+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stl_02"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"stl_view"},[_c('div',{staticClass:"stl_05 stl_06"},[_c('div',{staticClass:"stl_01",staticStyle:{"top":"30.3084em","left":"10.7871em"}},[_c('span',{attrs:{"id":"name"}},[_vm._v(_vm._s(_vm.$route.query.username))])]),_vm._v(" "),_c('div',{staticClass:"stl_01",staticStyle:{"top":"33.6418em","left":"10.7871em"}},[_c('span',{attrs:{"id":"age"}},[_vm._v(_vm._s(_vm.$route.query.grade))])]),_vm._v(" "),_c('div',{staticClass:"stl_01",staticStyle:{"top":"30.3084em","left":"32em"}},[_c('span',{attrs:{"id":"score"}},[_vm._v(_vm._s(_vm.$route.query.score))])]),_vm._v(" "),_c('div',{staticClass:"stl_01",staticStyle:{"top":"33.6418em","left":"32em"}},[_c('span',{attrs:{"id":"number"}},[_vm._v(_vm._s(_vm.$route.query.examNo))])]),_vm._v(" "),_c('div',{staticClass:"stl_01",staticStyle:{"top":"49.7704em","left":"7.4567em"}},[_c('span',{staticClass:"stl_15 stl_08 stl_09",attrs:{"id":"spell"}},[_vm._v(_vm._s(_vm.$route.query.spell))])]),_vm._v(" "),_c('div',{staticClass:"stl_01",staticStyle:{"top":"49.7704em","left":"15.9775em"}},[_c('span',{staticClass:"stl_15 stl_08 stl_09",attrs:{"id":"talk"}},[_vm._v(_vm._s(_vm.$route.query.dialogSpeak))])]),_vm._v(" "),_c('div',{staticClass:"stl_01",staticStyle:{"top":"49.7704em","left":"24.3477em"}},[_c('span',{staticClass:"stl_15 stl_08 stl_09",attrs:{"id":"word"}},[_vm._v(_vm._s(_vm.$route.query.wordSpeak))])]),_vm._v(" "),_c('div',{staticClass:"stl_01",staticStyle:{"top":"49.7704em","left":"32.7022em"}},[_c('span',{staticClass:"stl_15 stl_08 stl_09",attrs:{"id":"apply"}},[_vm._v(_vm._s(_vm.$route.query.comprehension))])]),_vm._v(" "),_c('div',{staticClass:"stl_01",staticStyle:{"top":"49.7704em","left":"41.2807em"}},[_c('span',{staticClass:"stl_15 stl_08 stl_09",attrs:{"id":"nosubtitle"}},[_vm._v(_vm._s(_vm.$route.query.speakUnaided))])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stl_03"},[_c('img',{staticStyle:{"position":"absolute","width":"50.75em","height":"72.75em"},attrs:{"src":__webpack_require__("ToU2"),"alt":""}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "D4UW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_db126702_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_home_page_vue__ = __webpack_require__("/2wM");
function injectStyle (ssrContext) {
  __webpack_require__("se3c")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-db126702"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_db126702_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_home_page_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DWGf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_voip_operate_vue__ = __webpack_require__("mSRY");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1a653108_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_voip_operate_vue__ = __webpack_require__("ZWhu");
function injectStyle (ssrContext) {
  __webpack_require__("SIIy")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1a653108"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_voip_operate_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_1a653108_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_voip_operate_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DaJ5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.printingPDF),expression:"!printingPDF"}],staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},on:{"change":_vm.chOrgType},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"filterable":"","clearable":"","placeholder":"学校"},model:{value:(_vm.filters.customer),callback:function ($$v) {_vm.$set(_vm.filters, "customer", $$v)},expression:"filters.customer"}},_vm._l((_vm.modCustomers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-form-item',[_vm._v("\n          课程类型:\n          "),_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"课程类型"},model:{value:(_vm.filters.featureId),callback:function ($$v) {_vm.$set(_vm.filters, "featureId", $$v)},expression:"filters.featureId"}},_vm._l(([{id:'6',name:'大声说英语'},{id:'9',name:'萌宠'},{id:'19',name:'宝宝说英语'}]),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_vm._v("\n          卡密类型:\n          "),_c('el-select',{attrs:{"filterable":"","placeholder":"卡密类型"},model:{value:(_vm.filters.cardType),callback:function ($$v) {_vm.$set(_vm.filters, "cardType", $$v)},expression:"filters.cardType"}},_vm._l(([{id:'all', name:'全部'},
                {id:'t4d365', name:'年卡'},
                {id:'d93', name:'季卡'},
                {id:'d62', name:'双月卡'},
                {id:'t3', name:'活动卡'},
                {id:'t1', name:'体验卡'},
                {id:'none', name:'无卡密'}
              ]),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canPrint),expression:"canPrint"}],attrs:{"type":"primary","icon":"el-icon-download"},on:{"click":_vm.genPdf}},[_vm._v("生成PDF")])],1)],1),_vm._v(" "),_c('div',{staticClass:"duration"},[_c('span',{staticClass:"label"},[_vm._v("当前查询时间段：")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.dateRange[0])+" 至 "+_vm._s(_vm.dateRange[1]))])])],1),_vm._v(" "),_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.printingPDF),expression:"printingPDF"}],staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.modCustomers.find(function (e){ return e.id===_vm.filters.customer; }) 
        && _vm.modCustomers.find(function (e){ return e.id===_vm.filters.customer; }).name))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.dateRange[0])+" ~ "+_vm._s(_vm.dateRange[1]))])]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("线上出勤情况")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.attendanceDistribute,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('pre',[_vm._v("          线上出勤人数：一定周期内，学习时长非0的用户数\n          总用户数：一定周期内，有过课程的用户数，包含在本周期内过期的用户\n          占比 = 线上出勤人数 / 总用户数")])]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("线上学习时长分布情况")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.learnDurationDistribute,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('pre',[_vm._v("          线上学习时长：一定周期内，同一用户学习时长的平均值\n          总用户数：一定周期内，有过课程的用户数，包含在本周期内过期的用户\n          占比 = 线上学习时长平均值到达某学习时长区间的人数 / 总用户数")])]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("星星获得情况")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.starDistribute,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('pre',[_vm._v("          星星数量：一定周期内，同一用户学习所获得的星星数量\n          总用户数：一定周期内，有过课程的用户数，包含在本周期内过期的用户\n          占比 = 星星数量到达某星星数量区间内的人数 / 总用户数")])]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("巧口秀使用情况")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.qoocoShowDistribute,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('pre',[_vm._v("          巧口秀视频数量：一定周期内，同一用户上传巧口秀视频的数量\n          总用户数：一定周期内，有过课程的用户数，包含在本周期内过期的用户\n          占比 = 上传巧口秀数量在某区间的人数 / 总用户数")])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      语吧周内详情\n      "),_c('small',[_vm._v("学习数据")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/learnDetails/learnDetails"}},[_vm._v("学习数据")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("语吧周内详情")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Dod7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = httpGet;
/* harmony export (immutable) */ __webpack_exports__["c"] = httpPost;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return baseUrl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("rVsN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);

function httpGet(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    window.Vue.http.get(url, {
      params: params
    }, { emulateJSON: false }).then(function (res) {
      var body = res.body;
      if (body.status === 'success') {
        console.log(body);
        resolve(body.data);
      } else {
        reject(body.msg);
      }
    }).catch(function (res) {
      var body = res.body;
      console.log(body.error);
      reject(body.msg);
    });
  });
}

function httpPost(url, params) {
  return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
    window.Vue.http.post(url, params, { emulateJSON: false }).then(function (res) {
      var body = res.body;
      if (body.status === 'success') {
        resolve(body.data);
      } else {
        reject(body.msg);
      }
    }).catch(function (res) {
      console.log(res);
      var body = res.body;
      reject(body.msg);
    });
  });
}

var baseUrl = 'https://open.api.qooco.com/ReportingAPI/';
// export const baseUrl = 'http://127.0.0.1:9999/ReportingAPI/'

/***/ }),

/***/ "Du/2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SET_CUSTOMERS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return SET_PICKER_OPTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return SET_ORG_TYPES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SET_ORG_CLASSES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SET_MODE_LIST; });
var SET_CUSTOMERS = 'SET_CUSTOMERS';
var SET_PICKER_OPTIONS = 'SET_PICKER_OPTIONS';
var SET_ORG_TYPES = 'SET_ORG_TYPES';
var SET_ORG_CLASSES = 'SET_ORG_CLASSES';
var SET_MODE_LIST = 'SET_MODE_LIST';

/***/ }),

/***/ "Eros":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f8bad40e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_err_404_vue__ = __webpack_require__("GQqH");
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_f8bad40e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_err_404_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "FVjE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_voip_details_vue__ = __webpack_require__("3lkS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4a584e6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_voip_details_vue__ = __webpack_require__("ghal");
function injectStyle (ssrContext) {
  __webpack_require__("4j6V")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a584e6b"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_voip_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_4a584e6b_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_voip_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "GQqH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content"},[_c('div',{staticClass:"error-page"},[_c('h2',{staticClass:"headline text-yellow"},[_vm._v(" 404")]),_vm._v(" "),_c('div',{staticClass:"error-content"},[_c('h3',[_c('i',{staticClass:"fa fa-warning text-yellow"}),_vm._v(" Oops! Page not found.")]),_vm._v(" "),_c('p',[_vm._v("\n          找不到页面.\n          返回"),_c('a',{attrs:{"href":"/"}},[_vm._v("主页")]),_vm._v(".\n        ")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GZRF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("fu2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_api_loud_speak_operate__ = __webpack_require__("hLvu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_js_common_utils__ = __webpack_require__("tqEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_api_base__ = __webpack_require__("Dod7");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["b" /* mapGetters */])(['customers', 'pickerOptions', 'orgTypes'])),
  data: function data() {
    return {
      // condition
      filters: {
        customers: [],
        orgType: 'school'
      },
      // pagination
      currentPage: 1,
      total: 0,
      pageSize: 10,
      listAll: [],
      // business
      userDetails: [],
      loading: true
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_3_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    sortChange: function sortChange(obj) {
      Object(__WEBPACK_IMPORTED_MODULE_6_common_js_common_utils__["g" /* sortChange */])(obj, this.listAll);
      this.handleCurrentChange(1);
    },
    pagination: function pagination(page, pageSize, all) {
      this.userDetails = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_common_utils__["f" /* pagination */])(page, pageSize, all);
      this.total = all.length;
    },
    exportUserDetails: function exportUserDetails() {
      var form = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<form>');
      form.attr('style', 'display:none');
      form.attr('target', '');
      form.attr('method', 'post');
      form.attr('action', __WEBPACK_IMPORTED_MODULE_7_api_base__["a" /* baseUrl */] + 'exports/exportUserDetails');
      var input1 = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<input>');
      var input2 = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<input>');
      input1.attr('type', 'hidden');
      input1.attr('name', 'conditionStr');
      input1.attr('value', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filters));
      input2.attr('type', 'hidden');
      input2.attr('name', 'token');
      input2.attr('value', localStorage.getItem('default_auth_token'));
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').append(form);
      form.append(input1);
      form.append(input2);
      form.submit();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.pagination(1, val, this.listAll);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.pagination(val, this.pageSize, this.listAll);
    },
    query: function query() {
      this._loadUserDetails(this.pageSize);
    },
    _loadUserDetails: function _loadUserDetails(pageSize) {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_5_api_loud_speak_operate__["e" /* loadUserDetails */])(this.filters).then(function (res) {
        _this.listAll = res.data;
        _this.handleSizeChange(pageSize);
      }, function (msg) {
        _this.$message.error(msg);
        _this.listAll = [];
        _this.handleSizeChange(pageSize);
      });
    }
  }
});

/***/ }),

/***/ "Hp6c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_login_vue__ = __webpack_require__("Bx0M");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0cdb1ba2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_login_vue__ = __webpack_require__("3YjS");
function injectStyle (ssrContext) {
  __webpack_require__("z57w")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cdb1ba2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_0cdb1ba2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IGnE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c586383a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_err_403_vue__ = __webpack_require__("BzwW");
var normalizeComponent = __webpack_require__("C7Lr")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_c586383a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_err_403_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("EqYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions__ = __webpack_require__("mUbh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__actions__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getters__ = __webpack_require__("UjVw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__state__ = __webpack_require__("lwq5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mutations__ = __webpack_require__("ukYY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__ = __webpack_require__("bg9d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger__);








__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  actions: __WEBPACK_IMPORTED_MODULE_2__actions__,
  getters: __WEBPACK_IMPORTED_MODULE_3__getters__,
  state: __WEBPACK_IMPORTED_MODULE_4__state__["a" /* default */],
  mutations: __WEBPACK_IMPORTED_MODULE_5__mutations__["a" /* default */],
  strict: debug,
  plugins: debug ? [__WEBPACK_IMPORTED_MODULE_6_vuex_dist_logger___default()()] : []
}));

/***/ }),

/***/ "JX9D":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "Gp/H",
	"./af.js": "Gp/H",
	"./ar": "4To2",
	"./ar-dz": "I+xr",
	"./ar-dz.js": "I+xr",
	"./ar-kw": "r+8p",
	"./ar-kw.js": "r+8p",
	"./ar-ly": "+buy",
	"./ar-ly.js": "+buy",
	"./ar-ma": "Btbr",
	"./ar-ma.js": "Btbr",
	"./ar-sa": "UyPZ",
	"./ar-sa.js": "UyPZ",
	"./ar-tn": "aXu8",
	"./ar-tn.js": "aXu8",
	"./ar.js": "4To2",
	"./az": "Depr",
	"./az.js": "Depr",
	"./be": "LHCG",
	"./be.js": "LHCG",
	"./bg": "nh9i",
	"./bg.js": "nh9i",
	"./bm": "BOPW",
	"./bm.js": "BOPW",
	"./bn": "Otk0",
	"./bn.js": "Otk0",
	"./bo": "hGwq",
	"./bo.js": "hGwq",
	"./br": "CYxw",
	"./br.js": "CYxw",
	"./bs": "YqrE",
	"./bs.js": "YqrE",
	"./ca": "uwhG",
	"./ca.js": "uwhG",
	"./cs": "qUx5",
	"./cs.js": "qUx5",
	"./cv": "YhfC",
	"./cv.js": "YhfC",
	"./cy": "I5uT",
	"./cy.js": "I5uT",
	"./da": "N4oI",
	"./da.js": "N4oI",
	"./de": "pN8S",
	"./de-at": "V407",
	"./de-at.js": "V407",
	"./de-ch": "qRJr",
	"./de-ch.js": "qRJr",
	"./de.js": "pN8S",
	"./dv": "NqKK",
	"./dv.js": "NqKK",
	"./el": "TQHB",
	"./el.js": "TQHB",
	"./en-au": "HCZ8",
	"./en-au.js": "HCZ8",
	"./en-ca": "7Y50",
	"./en-ca.js": "7Y50",
	"./en-gb": "N0C1",
	"./en-gb.js": "N0C1",
	"./en-ie": "OmmH",
	"./en-ie.js": "OmmH",
	"./en-nz": "Td0A",
	"./en-nz.js": "Td0A",
	"./eo": "pbqi",
	"./eo.js": "pbqi",
	"./es": "fE5E",
	"./es-do": "Bqhs",
	"./es-do.js": "Bqhs",
	"./es-us": "+iax",
	"./es-us.js": "+iax",
	"./es.js": "fE5E",
	"./et": "wSy5",
	"./et.js": "wSy5",
	"./eu": "iGKa",
	"./eu.js": "iGKa",
	"./fa": "L7ZU",
	"./fa.js": "L7ZU",
	"./fi": "MQYK",
	"./fi.js": "MQYK",
	"./fo": "qYiL",
	"./fo.js": "qYiL",
	"./fr": "KYc9",
	"./fr-ca": "yI2o",
	"./fr-ca.js": "yI2o",
	"./fr-ch": "eHwc",
	"./fr-ch.js": "eHwc",
	"./fr.js": "KYc9",
	"./fy": "kkzd",
	"./fy.js": "kkzd",
	"./gd": "vhGw",
	"./gd.js": "vhGw",
	"./gl": "YsEi",
	"./gl.js": "YsEi",
	"./gom-latn": "QFDI",
	"./gom-latn.js": "QFDI",
	"./gu": "mcQL",
	"./gu.js": "mcQL",
	"./he": "b2TT",
	"./he.js": "b2TT",
	"./hi": "AJMU",
	"./hi.js": "AJMU",
	"./hr": "Pbzx",
	"./hr.js": "Pbzx",
	"./hu": "ypZz",
	"./hu.js": "ypZz",
	"./hy-am": "M49r",
	"./hy-am.js": "M49r",
	"./id": "M5F1",
	"./id.js": "M5F1",
	"./is": "UvQK",
	"./is.js": "UvQK",
	"./it": "CDek",
	"./it.js": "CDek",
	"./ja": "cUKD",
	"./ja.js": "cUKD",
	"./jv": "yFpW",
	"./jv.js": "yFpW",
	"./ka": "kLav",
	"./ka.js": "kLav",
	"./kk": "jsV9",
	"./kk.js": "jsV9",
	"./km": "KMjM",
	"./km.js": "KMjM",
	"./kn": "2Q6X",
	"./kn.js": "2Q6X",
	"./ko": "6os7",
	"./ko.js": "6os7",
	"./ky": "TqNN",
	"./ky.js": "TqNN",
	"./lb": "VTbE",
	"./lb.js": "VTbE",
	"./lo": "t6jH",
	"./lo.js": "t6jH",
	"./lt": "Qi/3",
	"./lt.js": "Qi/3",
	"./lv": "DvoO",
	"./lv.js": "DvoO",
	"./me": "k2kb",
	"./me.js": "k2kb",
	"./mi": "xj+t",
	"./mi.js": "xj+t",
	"./mk": "eZ0d",
	"./mk.js": "eZ0d",
	"./ml": "DCZ9",
	"./ml.js": "DCZ9",
	"./mr": "DCyx",
	"./mr.js": "DCyx",
	"./ms": "C1vz",
	"./ms-my": "wobA",
	"./ms-my.js": "wobA",
	"./ms.js": "C1vz",
	"./my": "Jxbk",
	"./my.js": "Jxbk",
	"./nb": "3njd",
	"./nb.js": "3njd",
	"./ne": "M9WP",
	"./ne.js": "M9WP",
	"./nl": "mgSK",
	"./nl-be": "b8OV",
	"./nl-be.js": "b8OV",
	"./nl.js": "mgSK",
	"./nn": "IZ7I",
	"./nn.js": "IZ7I",
	"./pa-in": "o/m4",
	"./pa-in.js": "o/m4",
	"./pl": "dbdS",
	"./pl.js": "dbdS",
	"./pt": "MVVD",
	"./pt-br": "iedH",
	"./pt-br.js": "iedH",
	"./pt.js": "MVVD",
	"./ro": "kkXD",
	"./ro.js": "kkXD",
	"./ru": "XK+G",
	"./ru.js": "XK+G",
	"./sd": "zA8U",
	"./sd.js": "zA8U",
	"./se": "sP86",
	"./se.js": "sP86",
	"./si": "nwdi",
	"./si.js": "nwdi",
	"./sk": "HpCd",
	"./sk.js": "HpCd",
	"./sl": "/aIM",
	"./sl.js": "/aIM",
	"./sq": "hSTH",
	"./sq.js": "hSTH",
	"./sr": "ZJQb",
	"./sr-cyrl": "ZFBg",
	"./sr-cyrl.js": "ZFBg",
	"./sr.js": "ZJQb",
	"./ss": "kK8L",
	"./ss.js": "kK8L",
	"./sv": "IOtB",
	"./sv.js": "IOtB",
	"./sw": "NbHZ",
	"./sw.js": "NbHZ",
	"./ta": "r3Bs",
	"./ta.js": "r3Bs",
	"./te": "YHLT",
	"./te.js": "YHLT",
	"./tet": "5sug",
	"./tet.js": "5sug",
	"./th": "bbnR",
	"./th.js": "bbnR",
	"./tl-ph": "1z6D",
	"./tl-ph.js": "1z6D",
	"./tlh": "sVII",
	"./tlh.js": "sVII",
	"./tr": "UYbY",
	"./tr.js": "UYbY",
	"./tzl": "Xwzc",
	"./tzl.js": "Xwzc",
	"./tzm": "xGj/",
	"./tzm-latn": "eE5+",
	"./tzm-latn.js": "eE5+",
	"./tzm.js": "xGj/",
	"./uk": "MeoW",
	"./uk.js": "MeoW",
	"./ur": "M4nv",
	"./ur.js": "M4nv",
	"./uz": "Fyzr",
	"./uz-latn": "WdJm",
	"./uz-latn.js": "WdJm",
	"./uz.js": "Fyzr",
	"./vi": "fVew",
	"./vi.js": "fVew",
	"./x-pseudo": "KEef",
	"./x-pseudo.js": "KEef",
	"./yo": "Nihs",
	"./yo.js": "Nihs",
	"./zh-cn": "gPE8",
	"./zh-cn.js": "gPE8",
	"./zh-hk": "PY83",
	"./zh-hk.js": "PY83",
	"./zh-tw": "JP63",
	"./zh-tw.js": "JP63"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "JX9D";

/***/ }),

/***/ "LBR7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("IHPB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__("fu2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_api_base__ = __webpack_require__("Dod7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_api_learn_details__ = __webpack_require__("BM4Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_js_app_utils__ = __webpack_require__("r/qW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_common_js_common_utils__ = __webpack_require__("tqEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_condition__ = __webpack_require__("tc/g");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['customers', 'pickerOptions', 'orgTypes', 'orgClasses'])),
  data: function data() {
    return {
      currentDate: new Date(),
      dateRange: [],
      classes: [],
      filters: {
        customer: '',
        classId: '',
        orgClass: [],
        dateRange: [],
        orgType: ''
      },
      // pagination
      page: 1,
      total: 0,
      pageSize: 10,
      userListAll: [],
      // business
      learnDetails: []
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_3_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    sortChange: function sortChange(obj) {
      Object(__WEBPACK_IMPORTED_MODULE_9_common_js_common_utils__["g" /* sortChange */])(obj, this.userListAll);
      this.handleCurrentChange(1);
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.pagination(1, val, this.userListAll);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.pagination(val, this.pageSize, this.userListAll);
    },
    exportLearnDetails: function exportLearnDetails() {
      if (this.filters.orgClass.length === 0 && this.filters.classId === '') {
        this.$message.error('请先选择一个班级');
        return false;
      }
      var form = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<form>');
      form.attr('style', 'display:none');
      form.attr('target', '');
      form.attr('method', 'post');
      form.attr('action', __WEBPACK_IMPORTED_MODULE_5_api_base__["a" /* baseUrl */] + 'exports/exportLearnDetails');
      var input1 = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
      var input2 = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
      input1.attr('type', 'hidden');
      input1.attr('name', 'conditionStr');
      input1.attr('value', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.filters));
      input2.attr('type', 'hidden');
      input2.attr('name', 'token');
      input2.attr('value', localStorage.getItem('default_auth_token'));
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').append(form);
      form.append(input1);
      form.append(input2);
      form.submit();
    },
    exportAllClassLearnDetails: function exportAllClassLearnDetails() {
      if (this.filters.orgClass.length === 0 && this.filters.customer === '') {
        this.$message.error('请先选择一个学校');
        return false;
      }
      var form = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<form>');
      form.attr('style', 'display:none');
      form.attr('target', '');
      form.attr('method', 'post');
      form.attr('action', __WEBPACK_IMPORTED_MODULE_5_api_base__["a" /* baseUrl */] + 'exports/exportAllClassLearnDetails');
      var input1 = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
      var input2 = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
      var input3 = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
      input1.attr('type', 'hidden');
      input1.attr('name', 'classIds');
      input1.attr('value', this.getExportAllClassQuery());
      input2.attr('type', 'hidden');
      input2.attr('name', 'token');
      input2.attr('value', localStorage.getItem('default_auth_token'));
      input3.attr('type', 'hidden');
      input3.attr('name', 'conditionStr');
      input3.attr('value', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.filters));
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').append(form);
      form.append(input1);
      form.append(input2);
      form.append(input3);
      form.submit();
    },
    query: function query() {
      this._showDateRange();
      this._loadLearnDetails(this.filters);
    },
    getExportAllClassQuery: function getExportAllClassQuery() {
      var _this = this;

      if (this.filters.orgClass === '' && this.filters.customer === '') {
        this.$message.error('请先选择一个学校');
        return;
      }
      var arr = [];
      if (this.$auth.check('ROLE_QOOCO')) {
        // 巧口用户
        this.classes.forEach(function (clazz) {
          return arr.push(clazz.group_id);
        });
      } else {
        this.orgClasses.forEach(function (scoo) {
          if (scoo.value === _this.filters.orgClass[0]) {
            scoo.children.forEach(function (clazz) {
              return arr.push(clazz.value);
            });
          }
        });
      }
      return arr.join();
    },
    _showDateRange: function _showDateRange() {
      var t = this.filters.dateRange;
      if (t && t.length === 2) {
        this.dateRange = t;
      } else {
        this.dateRange = Object(__WEBPACK_IMPORTED_MODULE_8_common_js_app_utils__["d" /* getLastWeek */])();
      }
    },
    _loadLearnDetails: function _loadLearnDetails() {
      var _this2 = this;

      this.page = 1;
      Object(__WEBPACK_IMPORTED_MODULE_7_api_learn_details__["b" /* loadLearnDetails */])(this.filters).then(function (res) {
        _this2.userListAll = res;
        _this2.handleSizeChange(_this2.pageSize);
      }, function (msg) {
        _this2.$message.error(msg);
        _this2.summary = {};
        _this2.userListAll = [];
        _this2.handleSizeChange(_this2.pageSize);
      });
    },
    pagination: function pagination(page, pageSize, all) {
      this.learnDetails = Object(__WEBPACK_IMPORTED_MODULE_9_common_js_common_utils__["f" /* pagination */])(page, pageSize, all);
      this.total = all.length;
    },
    changeSchool: function changeSchool(val) {
      this.filters.classId = '';
      this._loadClasses();
    },
    _loadClasses: function _loadClasses() {
      var _this3 = this;

      // 接口只接受单选，所以这里需要将多选转为单选
      var orgId = this.filters.customer;
      var schoolIds = [orgId];
      Object(__WEBPACK_IMPORTED_MODULE_10_api_condition__["a" /* loadClasses */])(schoolIds).then(function (res) {
        var ret = [];
        Object(__WEBPACK_IMPORTED_MODULE_8_common_js_app_utils__["a" /* extractArrFromObj */])(res, 'groups').every(function (arr) {
          return ret.push.apply(ret, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arr));
        });
        _this3.classes = ret;
      }, function (msg) {
        _this3.classes = [];
      });
    }
  }
});

/***/ }),

/***/ "MhDS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  filters: {},
  methods: {}
});

/***/ }),

/***/ "N20J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("cUn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_loud_speak_learn__ = __webpack_require__("Xood");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__ = __webpack_require__("r/qW");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['customers', 'pickerOptions', 'orgTypes', 'modeList'])),
  data: function data() {
    return {
      scoreTabActive: 'avg',
      starTabActive: 'avg',
      currentDate: new Date(),
      dateRange: [],
      filters: {
        customers: [],
        dateRange: [],
        orgType: '',
        modeId: '0'
      },

      loading: true,
      loading1: true,
      style: {},
      scoreRanking: {
        title: {
          // text: '学习积分排行'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '20%', y: '9%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["g" /* subLabel */]
          }
        },
        series: [{
          name: '平均积分',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      totalscoreRanking: {
        title: {
          // text: '学习积分排行'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '20%', y: '9%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["g" /* subLabel */]
          }
        },
        series: [{
          name: '总积分',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },

      starRanking: {
        title: {
          // text: '学习星星排行'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '20%', y: '9%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["g" /* subLabel */]
          }
        },
        series: [{
          name: '星星平均值',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      totalstarRanking: {
        title: {
          // text: '学习星星排行'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '20%', y: '9%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["g" /* subLabel */]
          }
        },
        series: [{
          name: '星星总数',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },

      voicePrimary: {
        title: {
          text: '初级',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: []
        },
        series: [{
          name: '初级',
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [],
          color: ['rgb(91,155,213)', 'rgb(237,125,49)', 'rgb(165,165,165)', 'rgb(255,192,0)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      },

      voiceMiddle: {
        title: {
          text: '中级',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: []
        },
        series: [{
          name: '中级',
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [],
          color: ['rgb(91,155,213)', 'rgb(237,125,49)', 'rgb(165,165,165)', 'rgb(255,192,0)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      },

      voiceSenior: {
        title: {
          text: '高级',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: []
        },
        series: [{
          name: '高级',
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [],
          color: ['rgb(91,155,213)', 'rgb(237,125,49)', 'rgb(165,165,165)', 'rgb(255,192,0)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      },

      skillSpreadBL: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '14%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '技能分布',
          type: 'line',
          lineStyle: {
            normal: {
              width: 3,
              color: 'rgb(91,155,213)',
              shadowColor: 'rgba(0,0,0,0.4)',
              shadowBlur: 10,
              shadowOffsetY: 10
            }
          },
          data: [],
          color: ['rgb(91,155,213)']
        }]
      },

      skillSpreadPie: {
        title: {
          text: '',
          left: 'center'
        },
        tooltip: {
          trigger: 'item',
          formatter: '{a} <br/>{b} : {c} ({d}%)'
        },
        legend: {
          bottom: 10,
          left: 'center',
          data: []
        },
        series: [{
          name: '技能分布',
          type: 'pie',
          radius: '65%',
          center: ['50%', '50%'],
          selectedMode: 'single',
          data: [],
          color: ['rgb(91,155,213)', 'rgb(237,125,49)', 'rgb(165,165,165)', 'rgb(255,192,0)', 'rgb(68,114,196)'],
          itemStyle: {
            emphasis: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }]
      },

      courseRanking: {
        title: {
          text: '课程学习人数排行',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '20%', y: '15%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -38,
            formatter: __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["g" /* subLabel */]
          }
        },
        series: [{
          name: '人数（数目）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      }
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    changeCourse: function changeCourse() {
      this._loadModePackagesUsers(this.filters);
    },
    query: function query() {
      this._showDateRange();
      this._loadLearnAndSkillData(this.filters);
      this._loadModePackagesUsers(this.filters);
    },
    _showDateRange: function _showDateRange() {
      var t = this.filters.dateRange;
      if (t && t.length === 2) {
        this.dateRange = t;
      } else {
        this.dateRange = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["d" /* getLastWeek */])();
      }
    },
    _loadLearnAndSkillData: function _loadLearnAndSkillData() {
      var _this = this;

      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_4_api_loud_speak_learn__["a" /* loadLearnAndSkillData */])(this.filters).then(function (res) {
        _this.loading = false;
        _this.scoreRanking.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["j" /* withRank */])(res.points_ranking.keys.reverse(), res.points_ranking.ranks.reverse());
        _this.scoreRanking.series[0].data = res.points_ranking.values.reverse();
        // total score
        var arrs = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["b" /* extractArrsFromObj */])(res.total_points_ranking, ['name', 'value', 'ranking']);
        _this.totalscoreRanking.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["j" /* withRank */])(arrs.name, arrs.ranking);
        _this.totalscoreRanking.series[0].data = arrs.value;

        _this.starRanking.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["j" /* withRank */])(res.stars_ranking.keys.reverse(), res.stars_ranking.ranks.reverse());
        _this.starRanking.series[0].data = res.stars_ranking.values.reverse();
        // total star
        var arrs1 = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["b" /* extractArrsFromObj */])(res.total_stars_ranking, ['name', 'value', 'ranking']);
        _this.totalstarRanking.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["j" /* withRank */])(arrs1.name, arrs1.ranking);
        _this.totalstarRanking.series[0].data = arrs1.value;

        var _asr = res.asr;
        var _easyAsr = _this._parseAsr(_asr.easy);
        var _mediumAsr = _this._parseAsr(_asr.medium);
        var _hardAsr = _this._parseAsr(_asr.hard);
        _this.voicePrimary.legend.data = _easyAsr.keys;
        _this.voicePrimary.series[0].data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["f" /* parseValueName */])(_easyAsr.keys, _easyAsr.values);
        _this.voiceMiddle.legend.data = _mediumAsr.keys;
        _this.voiceMiddle.series[0].data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["f" /* parseValueName */])(_mediumAsr.keys, _mediumAsr.values);
        _this.voiceSenior.legend.data = _hardAsr.keys;
        _this.voiceSenior.series[0].data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["f" /* parseValueName */])(_hardAsr.keys, _hardAsr.values);

        var _skillSpread = _this._parseSkillSpread(res.skills_durs);
        _this.skillSpreadBL.xAxis.data = _skillSpread.keys;
        _this.skillSpreadBL.series[0].data = _skillSpread.values;

        _this.skillSpreadPie.legend.data = _skillSpread.keys;
        _this.skillSpreadPie.series[0].data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["f" /* parseValueName */])(_skillSpread.keys, _skillSpread.values);
      }, function (msg) {
        _this.loading = false;
        _this.$message.error(msg);
      });
    },
    _loadModePackagesUsers: function _loadModePackagesUsers() {
      var _this2 = this;

      this.loading1 = true;
      Object(__WEBPACK_IMPORTED_MODULE_4_api_loud_speak_learn__["c" /* loadModePackagesUsers */])(this.filters).then(function (res) {
        _this2.loading1 = false;
        _this2.courseRanking.title.text = res['mode_name'] + '\u5B66\u4E60\u4EBA\u6570\u6392\u884C';
        var courseArr = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["b" /* extractArrsFromObj */])(res.data, ['num', 'name']);
        _this2.courseRanking.yAxis.data = courseArr.name;
        _this2.courseRanking.series[0].data = courseArr.num;
      }, function (msg) {
        _this2.loading1 = false;
        _this2.$message.error(msg);
      });
    },
    _parseAsr: function _parseAsr(obj) {
      var map = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      map.set('excellent', '真棒');
      map.set('good', '很好');
      map.set('fair', '还不错');
      map.set('poor', '再试一次');
      return Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["e" /* parseTwoArray */])(obj, map);
    },
    _parseSkillSpread: function _parseSkillSpread(obj) {
      var map = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      map.set('speak_1', '说单词');
      map.set('dialogue_2', '说对话');
      map.set('nosub_speak_3', '无字幕对话');
      map.set('comprehension_4', '综合运用');
      map.set('spell_5', '单词拼写');
      return Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["e" /* parseTwoArray */])(obj, map);
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__("briU");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__("YkRm");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__("EqYI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("3XdE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_resource__ = __webpack_require__("y0Fx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fastclick__ = __webpack_require__("iDdd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui__ = __webpack_require__("mwE6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__ = __webpack_require__("cU5d");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css__ = __webpack_require__("uxEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_font_awesome_css_font_awesome_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css__ = __webpack_require__("lk8A");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_bootstrap_dist_css_bootstrap_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_js_bootstrap_min_js__ = __webpack_require__("ZOzM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_js_bootstrap_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_bootstrap_dist_js_bootstrap_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_css_skins_all_skins_min_css__ = __webpack_require__("2eDF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_assets_css_skins_all_skins_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_assets_css_skins_all_skins_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_css_AdminLTE_min_css__ = __webpack_require__("9h6Z");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_assets_css_AdminLTE_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_assets_css_AdminLTE_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_js_adminlte_js__ = __webpack_require__("Bx7T");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_assets_js_adminlte_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_assets_js_adminlte_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__router__ = __webpack_require__("YaEn");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_common_js_cookie_util__ = __webpack_require__("gZoB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_api_base__ = __webpack_require__("Dod7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_common_js_app_utils__ = __webpack_require__("r/qW");









// bootstrap


// AdminLTE










__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_5_fastclick___default.a.attach(document.body);

// Http
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.options.root = __WEBPACK_IMPORTED_MODULE_17_api_base__["a" /* baseUrl */];

__WEBPACK_IMPORTED_MODULE_2_vue__["default"].http.interceptors.push(function (request, next) {
  next(function (res) {
    if (res.status === 401) {
      localStorage.clear();
      Object(__WEBPACK_IMPORTED_MODULE_16_common_js_cookie_util__["a" /* delCookie */])('rememberMe');
      location.href = '/#/login';
    }
  });
});

// Router
var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  linkActiveClass: 'active',
  routes: __WEBPACK_IMPORTED_MODULE_14__router__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].router = router;

// Auth
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].use(__webpack_require__("NXk0"), {
  auth: __webpack_require__("51ZX"),
  http: __webpack_require__("a666"),
  router: __webpack_require__("HOhy"),
  rolesVar: 'roles'
});

window.Vue = __WEBPACK_IMPORTED_MODULE_2_vue__["default"];

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_2_vue__["default"]({
  router: __WEBPACK_IMPORTED_MODULE_2_vue__["default"].router,
  store: __WEBPACK_IMPORTED_MODULE_15__store__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__app__["default"]);
  }
}).$mount('#app');

window.onload = function () {
  sessionStorage.clear();
  // 隐藏谷歌翻译的操作面板
  // document.querySelector('.goog-te-banner-frame').style.display = 'none'
};

// global funciton fromClub
__WEBPACK_IMPORTED_MODULE_2_vue__["default"].prototype.fromClub = __WEBPACK_IMPORTED_MODULE_18_common_js_app_utils__["c" /* fromClub */];

/***/ }),

/***/ "NdhK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QCnd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "R8sk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_time_vue__ = __webpack_require__("heVJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_21a04d1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_time_vue__ = __webpack_require__("+A36");
function injectStyle (ssrContext) {
  __webpack_require__("dEMB")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-21a04d1a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_time_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_21a04d1a_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_time_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "SIIy":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "T5EG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "TLUP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_talent_show_vue__ = __webpack_require__("MhDS");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_15786bda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_talent_show_vue__ = __webpack_require__("CrP+");
function injectStyle (ssrContext) {
  __webpack_require__("T5EG")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_talent_show_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_15786bda_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_talent_show_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "TmyJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__("cUn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery__ = __webpack_require__("fu2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_loud_speak_operate__ = __webpack_require__("hLvu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__ = __webpack_require__("r/qW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_api_base__ = __webpack_require__("Dod7");


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["b" /* mapGetters */])(['customers', 'pickerOptions', 'orgTypes', 'modeList'])),
  data: function data() {
    return {
      // others
      otherSchool1: '',
      otherOrder1: '',
      otherSchool2: '',
      otherOrder2: '',
      otherSchool3: '',
      otherOrder3: '',
      // pagination
      page1: 1,
      page2: 1,
      page3: 1,
      total1: 0,
      total2: 0,
      total3: 0,
      pageSize: 10,

      currentDate: new Date(),
      dateRange: [],
      filters: {
        customers: [],
        dateRange: [],
        orgType: '',
        modeId: '0'
      },

      loading: true,
      loading1: true,
      loading2: true,
      loading3: true,
      loading4: true,
      loading5: true,
      orderUseRank: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '25%', y: '10%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: __WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["g" /* subLabel */]
          }
        },
        series: [{
          name: '订单（数量）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      mysUseRank: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '25%', y: '10%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -42,
            formatter: __WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["h" /* subLabelM */]
          }
        },
        series: [{
          name: 'Mys系统（充值卡数量）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      userUseRank: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '25%', y: '10%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -42,
            formatter: __WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["h" /* subLabelM */]
          }
        },
        series: [{
          name: '用户（数量）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      ordersSum: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          },
          formatter: __WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["i" /* tooltipWithSum */]
        },
        grid: { x: '13%', y: '14%', width: '70%', height: '75%' },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        legend: {
          orient: 'vertical',
          top: '30%',
          left: 'right',
          data: ['充值卡充值', 'Mys系统充值']
        },
        series: [{
          name: 'Mys系统充值',
          type: 'bar',
          stack: '总量',
          itemStyle: { normal: { label: { show: true, position: 'inside' } } },
          data: [],
          color: ['rgb(255,192,0)']
        }, {
          name: '充值卡充值',
          type: 'bar',
          stack: '总量',
          itemStyle: { normal: { label: { show: true, position: 'inside' } } },
          data: [],
          color: ['rgb(237,125,49)']
        }]
      },
      modeOrders: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '13%', y: '14%', width: '70%', height: '75%' },
        xAxis: {
          type: 'category',
          data: []
        },
        yAxis: {
          type: 'value'
        },
        legend: {
          orient: 'vertical',
          top: '30%',
          left: 'right',
          data: ['两年卡', '年卡', '半年卡', '季卡', '两月卡', '月卡（包括≤31天的充值）', '折合为月卡', '其他']
        },
        series: [{
          name: '两年卡',
          type: 'bar',
          data: []
        }, {
          name: '年卡',
          type: 'bar',
          data: []
        }, {
          name: '半年卡',
          type: 'bar',
          data: []
        }, {
          name: '季卡',
          type: 'bar',
          data: []
        }, {
          name: '两月卡',
          type: 'bar',
          data: []
        }, {
          name: '月卡（包括≤31天的充值）',
          type: 'bar',
          data: []
        }, {
          name: '折合为月卡',
          type: 'bar',
          data: []
        }, {
          name: '其他',
          type: 'bar',
          data: []
        }]
        // color: ['rgb(255,192,0)', 'rgb(237,125,49)', 'rgba(222, 66, 67, 1)', 'rgba(53, 74, 95, 1)', 'rgba(101, 154, 42, 1)']
      }
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_3_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    exportOrders: function exportOrders(type_) {
      var form = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<form>');
      form.attr('style', 'display:none');
      form.attr('target', '');
      form.attr('method', 'post');
      form.attr('action', __WEBPACK_IMPORTED_MODULE_7_api_base__["a" /* baseUrl */] + ('exports/orders/' + type_));
      var input = __WEBPACK_IMPORTED_MODULE_2_jquery___default()('<input>');
      input.attr('type', 'hidden');
      input.attr('name', 'token');
      input.attr('value', localStorage.getItem('default_auth_token'));
      __WEBPACK_IMPORTED_MODULE_2_jquery___default()('body').append(form);
      form.append(input);
      form.submit();
    },
    handleCurrentChange1: function handleCurrentChange1(val) {
      this._loadOrderUseRank(val, this.pageSize);
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this._loadMysUseRank(val, this.pageSize);
    },
    handleCurrentChange3: function handleCurrentChange3(val) {
      this._loadUserUseRank(val, this.pageSize);
    },
    query: function query() {
      this._showDateRange();
      this._loadOrderUseRank(1, this.pageSize);
      this._loadMysUseRank(1, this.pageSize);
      this._loadUserUseRank(1, this.pageSize);
      this._loadOrdersSum();
      this._loadModeOrders();
    },
    _showDateRange: function _showDateRange() {
      var t = this.filters.dateRange;
      if (t && t.length === 2) {
        this.dateRange = t;
      } else {
        this.dateRange = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["d" /* getLastWeek */])();
      }
    },
    _loadOrderUseRank: function _loadOrderUseRank(page, pageSize) {
      var _this = this;

      this.loading1 = true;
      Object(__WEBPACK_IMPORTED_MODULE_4_api_loud_speak_operate__["c" /* loadOrderUseRank */])(page, pageSize, this.filters).then(function (res) {
        _this.loading1 = false;
        var arrs = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["b" /* extractArrsFromObj */])(res.rows, ['school', 'num', 'rank']);
        var schoolWithRank = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["j" /* withRank */])(arrs.school, arrs.rank);
        _this.orderUseRank.yAxis.data = schoolWithRank;
        _this.orderUseRank.series[0].data = arrs.num;
        _this.total1 = res.total;
        var other = res.others;
        if (other && (_this.orgType === 'all' || !_this.orgType)) {
          _this.otherSchool1 = other.school + ' [' + other.rank + ']';
          _this.otherOrder1 = other.num;
        } else if (_this.page1 === 1) {
          _this.otherSchool1 = '';
        }
      }, function (msg) {
        _this.loading1 = false;
        _this.orderUseRank.yAxis.data = '';
        _this.orderUseRank.series[0].data = '';
        _this.total1 = '';
        _this.$message.error(msg);
      });
    },
    _loadMysUseRank: function _loadMysUseRank(page, pageSize) {
      var _this2 = this;

      this.loading2 = true;
      Object(__WEBPACK_IMPORTED_MODULE_4_api_loud_speak_operate__["b" /* loadMysUseRank */])(page, pageSize, this.filters).then(function (res) {
        _this2.loading2 = false;
        var arrs = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["b" /* extractArrsFromObj */])(res.rows, ['school', 'num', 'rank']);
        var schoolWithRank = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["j" /* withRank */])(arrs.school, arrs.rank);
        _this2.mysUseRank.yAxis.data = schoolWithRank;
        _this2.mysUseRank.series[0].data = arrs.num;
        _this2.total2 = res.total;
        var other = res.others;
        if (other && (_this2.orgType === 'all' || !_this2.orgType)) {
          _this2.otherSchool2 = other.school + ' [' + other.rank + ']';
          _this2.otherOrder2 = other.num;
        } else if (_this2.page2 === 1) {
          _this2.otherSchool2 = '';
        }
      }, function (msg) {
        _this2.loading2 = false;
        _this2.mysUseRank.yAxis.data = '';
        _this2.mysUseRank.series[0].data = '';
        _this2.total2 = '';
        _this2.otherSchool2 = '';
        _this2.$message.error(msg);
      });
    },
    _loadUserUseRank: function _loadUserUseRank(page, pageSize) {
      var _this3 = this;

      this.loading3 = true;
      Object(__WEBPACK_IMPORTED_MODULE_4_api_loud_speak_operate__["f" /* loadUserUseRank */])(page, pageSize, this.filters).then(function (res) {
        _this3.loading3 = false;
        var arrs = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["b" /* extractArrsFromObj */])(res.rows, ['school', 'num', 'rank']);
        var schoolWithRank = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["j" /* withRank */])(arrs.school, arrs.rank);
        _this3.userUseRank.yAxis.data = schoolWithRank;
        _this3.userUseRank.series[0].data = arrs.num;
        _this3.total3 = res.total;
        var other = res.others;
        if (other && (_this3.orgType === 'all' || !_this3.orgType)) {
          _this3.otherSchool3 = other.school + ' [' + other.rank + ']';
          _this3.otherOrder3 = other.num;
        } else if (_this3.page3 === 1) {
          _this3.otherSchool3 = '';
        }
      }, function (msg) {
        _this3.loading3 = false;
        _this3.userUseRank.yAxis.data = '';
        _this3.userUseRank.series[0].data = '';
        _this3.total3 = '';
        _this3.otherSchool3 = '';
        _this3.$message.error(msg);
      });
    },
    _loadOrdersSum: function _loadOrdersSum() {
      var _this4 = this;

      this.loading5 = true;
      Object(__WEBPACK_IMPORTED_MODULE_4_api_loud_speak_operate__["d" /* loadOrdersSum */])(this.filters).then(function (res) {
        console.log(res);
        _this4.loading5 = false;
        var _res = {};
        res.forEach(function (obj) {
          if (obj.from_mys === 'true') {
            _res.fromMys = obj.data;
          } else {
            _res.notFromMys = obj.data;
          }
        });
        console.log(_res);
        var fromMys = _this4._parseAllCardUse(_res.fromMys);
        var notFromMys = _this4._parseAllCardUse(_res.notFromMys);
        console.log(fromMys);
        _this4.ordersSum.xAxis.data = fromMys.keys;
        _this4.ordersSum.series[0].data = fromMys.values;
        _this4.ordersSum.series[1].data = notFromMys.values;
      }, function (msg) {
        _this4.loading5 = false;
        _this4.$message.error(msg);
      });
    },
    _loadModeOrders: function _loadModeOrders() {
      var _this5 = this;

      this.loading4 = true;
      Object(__WEBPACK_IMPORTED_MODULE_4_api_loud_speak_operate__["a" /* loadModeOrders */])(this.filters).then(function (res) {
        _this5.loading4 = false;
        var arrs = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["b" /* extractArrsFromObj */])(res, ['mode_name', 'data']);
        var dataArrs = Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["b" /* extractArrsFromObj */])(arrs.data, ['month_1', 'month_2', 'month_3', 'month_6', 'month_12', 'month_24', 'month_13', 'convert_month_1']);
        _this5.modeOrders.xAxis.data = arrs.mode_name;
        _this5.modeOrders.series[0].data = dataArrs.month_24;
        _this5.modeOrders.series[1].data = dataArrs.month_12;
        _this5.modeOrders.series[2].data = dataArrs.month_6;
        _this5.modeOrders.series[3].data = dataArrs.month_3;
        _this5.modeOrders.series[4].data = dataArrs.month_2;
        _this5.modeOrders.series[5].data = dataArrs.month_1;
        _this5.modeOrders.series[6].data = dataArrs.convert_month_1;
        _this5.modeOrders.series[7].data = dataArrs.month_13;
      }, function (msg) {
        _this5.loading4 = false;
        _this5.$message.error(msg);
      });
    },
    _parseAllCardUse: function _parseAllCardUse(obj) {
      if (!obj) {
        // 兼容API返回格式错误
        obj = {
          month_24: 0,
          month_12: 0,
          month_6: 0,
          month_3: 0,
          month_2: 0,
          month_1: 0,
          convert_month_1: 0,
          month_13: 0
        };
      }
      var map = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
      map.set('month_24', '两年卡');
      map.set('month_12', '年卡');
      map.set('month_6', '半年卡');
      map.set('month_3', '季卡');
      map.set('month_2', '两月卡');
      map.set('month_1', '月卡');
      map.set('convert_month_1', '折合为月卡张数');
      map.set('month_13', '其他');
      return Object(__WEBPACK_IMPORTED_MODULE_6_common_js_app_utils__["e" /* parseTwoArray */])(obj, map);
    }
  }
});

/***/ }),

/***/ "ToU2":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/bg_font.4fa335d.jpg";

/***/ }),

/***/ "TxS/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_and_skill_vue__ = __webpack_require__("N20J");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_723704c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_and_skill_vue__ = __webpack_require__("2POs");
function injectStyle (ssrContext) {
  __webpack_require__("BKMg")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-723704c4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_and_skill_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_723704c4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_and_skill_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "U/dz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[(_vm.$auth.check('ROLE_SCHOOL'))?_c('el-form-item',[_c('el-cascader',{staticStyle:{"width":"360px"},attrs:{"placeholder":"学校及班级","expand-trigger":"hover","options":_vm.orgClasses},model:{value:(_vm.filters.orgClass),callback:function ($$v) {_vm.$set(_vm.filters, "orgClass", $$v)},expression:"filters.orgClass"}})],1):_vm._e(),_vm._v(" "),(_vm.$auth.check('ROLE_QOOCO'))?_c('el-form-item',[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"filterable":"","clearable":"","placeholder":"学校"},on:{"change":_vm.changeSchool},model:{value:(_vm.filters.customer),callback:function ($$v) {_vm.$set(_vm.filters, "customer", $$v)},expression:"filters.customer"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1):_vm._e(),_vm._v(" "),(_vm.$auth.check('ROLE_QOOCO'))?_c('el-form-item',[_c('el-select',{staticStyle:{"width":"300px"},attrs:{"filterable":"","clearable":"","placeholder":"班级"},model:{value:(_vm.filters.classId),callback:function ($$v) {_vm.$set(_vm.filters, "classId", $$v)},expression:"filters.classId"}},_vm._l((_vm.classes),function(item){return _c('el-option',{key:item.group_id,attrs:{"label":item.name,"value":item.group_id}})}),1)],1):_vm._e(),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1),_vm._v(" "),_c('div',{staticClass:"duration"},[_c('span',{staticClass:"label"},[_vm._v("当前查询时间段：")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.dateRange[0])+" 至 "+_vm._s(_vm.dateRange[1]))])])],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("学习详细数据")]),_vm._v(" "),_c('el-button',{attrs:{"id":"exportBtn","type":"primary","icon":"el-icon-download"},on:{"click":_vm.exportLearnDetails}},[_vm._v("导出")]),_vm._v(" "),_c('el-button',{attrs:{"id":"exportBtn","type":"primary","icon":"el-icon-download"},on:{"click":_vm.exportAllClassLearnDetails}},[_vm._v("导出所有班级")])],1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('el-table',{attrs:{"border":"","data":_vm.learnDetails,"default-sort":{prop: 'name', order: 'ascending'}},on:{"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"type":"index"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"学生名称","sortable":"custom"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"studyMins","label":"学习时长/min","sortable":"custom","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"daysMore5Mins","label":"学习时长分布","sortable":"custom","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"points","label":"积分","sortable":"custom","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"stars","label":"星星","sortable":"custom","align":"center"}})],1),_vm._v(" "),_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 30, 50, 100],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      学生数据\n      "),_c('small',[_vm._v("学习数据")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/learnDetails/learnDetails"}},[_vm._v("学习数据")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("学生数据")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U1yt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper"},[_c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      500 Error Page\n    ")]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#"}},[_vm._v("Examples")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("500 error")])])]),_vm._v(" "),_c('section',{staticClass:"content"},[_c('div',{staticClass:"error-page"},[_c('h2',{staticClass:"headline text-red"},[_vm._v("500")]),_vm._v(" "),_c('div',{staticClass:"error-content"},[_c('h3',[_c('i',{staticClass:"fa fa-warning text-red"}),_vm._v(" Oops! Something went wrong.")]),_vm._v(" "),_c('p',[_vm._v("\n          服务器内部错误.\n          返回"),_c('a',{attrs:{"href":"/"}},[_vm._v("主页")]),_vm._v(".\n        ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UjVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clubCustomers", function() { return clubCustomers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "customers", function() { return customers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pickerOptions", function() { return pickerOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgTypes", function() { return orgTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orgClasses", function() { return orgClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modeList", function() { return modeList; });
var clubCustomers = function clubCustomers(state) {
  return state.customers.filter(function (t) {
    return t.type === 'club';
  });
};
var customers = function customers(state) {
  return state.customers;
};
var pickerOptions = function pickerOptions(state) {
  return state.pickerOptions;
};
var orgTypes = function orgTypes(state) {
  return state.orgTypes;
};
var orgClasses = function orgClasses(state) {
  return state.orgClasses;
};
var modeList = function modeList(state) {
  return state.modeList;
};

/***/ }),

/***/ "WAKP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"multiple":"","filterable":"","clearable":"","placeholder":"客户名称"},model:{value:(_vm.filters.customers),callback:function ($$v) {_vm.$set(_vm.filters, "customers", $$v)},expression:"filters.customers"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("用户详细数据")]),_vm._v(" "),_c('el-button',{attrs:{"id":"exportBtn","type":"primary","icon":"el-icon-download"},on:{"click":_vm.exportUserDetails}},[_vm._v("导出")])],1),_vm._v(" "),_c('div',{staticClass:"content"},[_c('el-table',{attrs:{"border":"","data":_vm.userDetails,"default-sort":{prop: 'org_name', order: 'ascending'}},on:{"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"prop":"org_name","label":"客户名称","sortable":"custom","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_orders","label":"总订单数","sortable":"custom","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_card_orders","label":"总卡密订单数","sortable":"custom","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_mys_orders","label":"总MIS订单数","sortable":"custom","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"tt_ordered_users","label":"总订单用户数","sortable":"custom","width":"100"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"total_register_users","label":"总注册用户数","sortable":"custom","width":"100"}})],1),_vm._v(" "),_c('el-pagination',{attrs:{"current-page":_vm.currentPage,"page-sizes":[10, 20, 30, 50, 100],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      学校订单历史明细\n      "),_c('small',[_vm._v("订单综合排行榜")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/loudSpeakLearn/learnTime"}},[_vm._v("订单综合排行榜")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("学校订单历史明细")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Xood":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadLearnTimeData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadLearnAndSkillData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadModePackagesUsers; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("Dod7");

// tab1 学习时长数据
var loadLearnTimeData = function loadLearnTimeData(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakLearn/learnTime', params).then(function (res) {
    return res;
  });
};
// tab2 学习及技能数据
var loadLearnAndSkillData = function loadLearnAndSkillData(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakLearn/learnAndSkill', params).then(function (res) {
    return res;
  });
};
var loadModePackagesUsers = function loadModePackagesUsers(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakLearn/modePackagesUsers', params).then(function (res) {
    return res;
  });
};

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_components_sys_err_403__ = __webpack_require__("IGnE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_components_sys_err_404__ = __webpack_require__("Eros");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_components_sys_err_502__ = __webpack_require__("ASCY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_components_sys_login__ = __webpack_require__("Hp6c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__ = __webpack_require__("zCZ4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_components_sys_home_home_page__ = __webpack_require__("D4UW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_components_loud_speak_learn_learn_time__ = __webpack_require__("R8sk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_components_loud_speak_learn_learn_and_skill__ = __webpack_require__("TxS/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_components_loud_speak_operate_order__ = __webpack_require__("oCn3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_components_loud_speak_operate_user__ = __webpack_require__("qdC4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_components_voip_operate_voip_operate__ = __webpack_require__("DWGf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_components_learn_details_learn_details__ = __webpack_require__("9h+P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_components_learn_details_learn_details_qoocobar__ = __webpack_require__("wqmp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_components_learn_details_learn_details_clubweeks__ = __webpack_require__("7Gw5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_components_voip_details_voip_details__ = __webpack_require__("FVjE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_components_operate_details_operate_details__ = __webpack_require__("zrQv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_components_card_course_search_card_search__ = __webpack_require__("poY2");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_components_card_course_search_course_search__ = __webpack_require__("dpoh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_components_english_certificate_talent_show__ = __webpack_require__("TLUP");













// import LearnDetailsSchool from 'components/learn-details/learn-details-school'






// English Certificate

// lazy load
var cardFinance = function cardFinance() {
  return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "PZMG"));
};
var clubWeekMonth = function clubWeekMonth() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "w098"));
};
var clubWeekMonthSg = function clubWeekMonthSg() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "LvZz"));
};
var aiData = function aiData() {
  return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "ZTtV"));
};
// wildData
var exportExcel = function exportExcel() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "k1yd"));
};
// quickData
var quickData = function quickData() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "UNHj"));
};
// {roles: 'ROLE_QOOCO'}
var routes = [{ path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: true },
  hidden: true,
  children: [{ path: '/', component: __WEBPACK_IMPORTED_MODULE_5_components_sys_home_home_page__["a" /* default */], name: 'default', hidden: true }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: 'ROLE_QOOCO' } },
  name: 'loudSpeakLearn',
  alias: '学习综合项排行榜',
  children: [{ path: '/loudSpeakLearn/learnTime', component: __WEBPACK_IMPORTED_MODULE_6_components_loud_speak_learn_learn_time__["a" /* default */], name: 'loudSpeakLearnLearnTime', alias: '时间排行', meta: { auth: { roles: 'ROLE_QOOCO' } } }, { path: '/loudSpeakLearn/learnAndSkill', component: __WEBPACK_IMPORTED_MODULE_7_components_loud_speak_learn_learn_and_skill__["a" /* default */], name: 'loudSpeakLearnLearnAndSkill', alias: '其它单项排行', meta: { auth: { roles: 'ROLE_QOOCO' } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: 'ROLE_QOOCO' } },
  name: 'loudSpeakOperate',
  alias: '订单综合排行榜',
  children: [{ path: '/loudSpeakOperate/order', component: __WEBPACK_IMPORTED_MODULE_8_components_loud_speak_operate_order__["a" /* default */], name: 'operateOrder', alias: '订单排行', meta: { auth: { roles: 'ROLE_QOOCO' } } }, { path: '/loudSpeakOperate/user', component: __WEBPACK_IMPORTED_MODULE_9_components_loud_speak_operate_user__["a" /* default */], name: 'operateUser', alias: '学校订单历史明细', meta: { auth: { roles: 'ROLE_QOOCO' } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: 'ROLE_DEV' } },
  name: 'voipOperate',
  alias: 'VoIP运营数据',
  children: [{ path: '/voipOperate/voipOperate', component: __WEBPACK_IMPORTED_MODULE_10_components_voip_operate_voip_operate__["a" /* default */], name: 'operateOrder1', alias: 'VoIP运营数据', meta: { auth: { roles: 'ROLE_QOOCO' } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: ['ROLE_QOOCO', 'ROLE_SCHOOL'] } },
  name: 'learnDetails',
  alias: '学习数据',
  children: [{ path: '/learnDetails/learnDetails', component: __WEBPACK_IMPORTED_MODULE_11_components_learn_details_learn_details__["a" /* default */], name: 'learnDetails1', alias: '学生数据', meta: { auth: { roles: ['ROLE_QOOCO', 'ROLE_SCHOOL'] } } },
  // { path: '/learnDetails/school', component: LearnDetailsSchool, name: 'learnDetails2', alias: '学校数据' },
  { path: '/learnDetails/qoocobar', component: __WEBPACK_IMPORTED_MODULE_12_components_learn_details_learn_details_qoocobar__["a" /* default */], name: 'learnDetails3', alias: '语吧周内详情', meta: { auth: { roles: ['ROLE_QOOCO', 'ROLE_SCHOOL'] } } }, { path: '/learnDetails/clubWeeks', component: __WEBPACK_IMPORTED_MODULE_13_components_learn_details_learn_details_clubweeks__["a" /* default */], name: 'learnDetails4', alias: '语吧周度对比', meta: { auth: { roles: ['ROLE_QOOCO', 'ROLE_SCHOOL'] } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: 'ROLE_DEV' } },
  name: 'voipDetails',
  alias: 'VoIP详细数据',
  children: [{ path: '/voipDetails/voipDetails', component: __WEBPACK_IMPORTED_MODULE_14_components_voip_details_voip_details__["a" /* default */], name: 'voipDetails1', alias: 'VoIP详细数据', meta: { auth: { roles: 'ROLE_QOOCO' } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: ['ROLE_QOOCO', 'ROLE_SCHOOL'] } },
  name: 'operateDetails',
  alias: '充值卡综合数据',
  children: [{ path: '/operateDetails/operateDetails', component: __WEBPACK_IMPORTED_MODULE_15_components_operate_details_operate_details__["a" /* default */], name: 'operateDetails1', alias: '学生充值卡明细', meta: { auth: { roles: ['ROLE_QOOCO', 'ROLE_SCHOOL'] } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: 'ROLE_QOOCO' } },
  name: 'cardAndCourseSearch',
  alias: '快速查询工具',
  children: [{ path: '/cardAndCourseSearch/cardSearch', component: __WEBPACK_IMPORTED_MODULE_16_components_card_course_search_card_search__["a" /* default */], name: 'CardSearch', alias: '卡密查询', meta: { auth: { roles: 'ROLE_QOOCO' } } }, { path: '/cardAndCourseSearch/courseSearch', component: __WEBPACK_IMPORTED_MODULE_17_components_card_course_search_course_search__["a" /* default */], name: 'CourseSearch', alias: '用户卡密及课程查询', meta: { auth: { roles: 'ROLE_QOOCO' } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: 'ROLE_QOOCO' } },
  name: 'headquarters',
  alias: '总部数据统计',
  children: [{ path: '/headquarters/cardFinance', component: cardFinance, name: 'cardFinance', alias: '卡密/财务数据', meta: { auth: { roles: 'ROLE_QOOCO' } } }, { path: '/headquarters/clubWeekMonth', component: clubWeekMonth, name: 'clubWeekMonth', alias: '语吧周、月数据', meta: { auth: { roles: 'ROLE_QOOCO' } } }, { path: '/headquarters/clubWeekMonthSg', component: clubWeekMonthSg, name: 'clubWeekMonthSg', alias: '语吧周、月数据-海外', meta: { auth: { roles: 'ROLE_QOOCO' } } }, { path: '/headquarters/aiData', component: aiData, name: 'aiData', alias: '巧口AI英语数据', meta: { auth: { roles: 'ROLE_QOOCO' } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: 'ROLE_QOOCO' } },
  name: 'wildData',
  alias: '未归类数据',
  children: [{ path: '/wildData/exportExcel', component: exportExcel, name: 'exportExcel', alias: '导出Excel', meta: { auth: { roles: 'ROLE_QOOCO' } } }]
}, {
  path: '/',
  component: __WEBPACK_IMPORTED_MODULE_4_components_sys_home_home__["a" /* default */],
  meta: { auth: { roles: 'ROLE_QOOCO' } },
  name: 'quickData',
  alias: '快速导出数据',
  children: [{ path: '/quickData/exportExcel', component: quickData, name: 'quickData', alias: '导出Excel', meta: { auth: { roles: 'ROLE_QOOCO' } } }]
}, {
  path: '/login',
  component: __WEBPACK_IMPORTED_MODULE_3_components_sys_login__["a" /* default */],
  name: 'login',
  alias: '登录',
  meta: {
    auth: false
  },
  hidden: true
}, {
  path: '/403',
  name: 'error-403',
  component: __WEBPACK_IMPORTED_MODULE_0_components_sys_err_403__["a" /* default */],
  hidden: true
}, {
  path: '/404',
  name: 'error-404',
  component: __WEBPACK_IMPORTED_MODULE_1_components_sys_err_404__["a" /* default */],
  hidden: true
}, {
  path: '/502',
  name: 'error502',
  component: __WEBPACK_IMPORTED_MODULE_2_components_sys_err_502__["a" /* default */],
  hidden: true
}, {
  path: '/talentshow',
  name: 'talentshow',
  component: __WEBPACK_IMPORTED_MODULE_18_components_english_certificate_talent_show__["a" /* default */],
  meta: {
    auth: false
  },
  hidden: true
}];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "YkRm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_app_vue__ = __webpack_require__("t3m8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_app_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_app_vue__);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_38891ec6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_app_vue__ = __webpack_require__("QCnd");
function injectStyle (ssrContext) {
  __webpack_require__("jrL8")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_app_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_38891ec6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_app_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZWhu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',[_c('el-select',{attrs:{"multiple":"","filterable":"","clearable":"","placeholder":"客户名称"},model:{value:(_vm.filters.customers),callback:function ($$v) {_vm.$set(_vm.filters, "customers", $$v)},expression:"filters.customers"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("VoIP充值卡数量统计")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.rechargeCard,"resizable":true,"loading":_vm.loading1}})],1),_vm._v(" "),_c('el-pagination',{attrs:{"current-page":_vm.currentPage1,"page-size":_vm.pageSize,"layout":"total, prev, pager, next","total":_vm.total1},on:{"current-change":_vm.handleCurrentChange1,"update:currentPage":function($event){_vm.currentPage1=$event},"update:current-page":function($event){_vm.currentPage1=$event}}})],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("VoIP充值卡使用数量统计")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.rechargeCardUse,"resizable":true,"loading":_vm.loading2}})],1),_vm._v(" "),_c('el-pagination',{attrs:{"current-page":_vm.currentPage2,"page-size":_vm.pageSize,"layout":"total, prev, pager, next","total":_vm.total2},on:{"current-change":_vm.handleCurrentChange2,"update:currentPage":function($event){_vm.currentPage2=$event},"update:current-page":function($event){_vm.currentPage2=$event}}})],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('el-row',{attrs:{"gutter":40,"justify":"center"}},[_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('center',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"已使用次数 / 已充值次数","placement":"top"}},[_c('h5',[_vm._v("使用率")])]),_vm._v(" "),_c('el-progress',{attrs:{"type":"circle","percentage":_vm.useRate}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('center',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"取消次数 / 已预约次数","placement":"top"}},[_c('h5',[_vm._v("取消率")])]),_vm._v(" "),_c('el-progress',{attrs:{"type":"circle","percentage":_vm.cancelRate}})],1)],1),_vm._v(" "),_c('el-col',{attrs:{"xs":24,"sm":12,"md":8}},[_c('center',[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"预约课程大于等于两次的用户数 / 所有使用次数的用户数","placement":"top"}},[_c('h5',[_vm._v("续约率")])]),_vm._v(" "),_c('el-progress',{attrs:{"type":"circle","percentage":_vm.continueRate}})],1)],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("预约课程排行榜")])]),_vm._v(" "),_c('div',{staticClass:"echart one-two"},[_c('IEcharts',{attrs:{"option":_vm.subOne2one,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('div',{staticClass:"echart one-two"},[_c('IEcharts',{attrs:{"option":_vm.subOne2many,"resizable":true,"loading":_vm.loading}})],1)]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("VoIP学习时间分布")])]),_vm._v(" "),_c('div',{staticClass:"echart one-two"},[_c('IEcharts',{attrs:{"option":_vm.durationSpread,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('div',{staticClass:"echart one-two"},[_c('IEcharts',{attrs:{"option":_vm.weekSpread,"resizable":true,"loading":_vm.loading}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      VoIP运营数据\n      "),_c('small',[_vm._v("VoIP运营数据")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/voipOperate/voipOperate"}},[_vm._v("VoIP运营数据")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("VoIP运营数据")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "aIfx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bJQK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "bOaH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(!_vm.printingPDF),expression:"!printingPDF"}],staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},on:{"change":_vm.chOrgType},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"filterable":"","clearable":"","placeholder":"学校"},model:{value:(_vm.filters.customer),callback:function ($$v) {_vm.$set(_vm.filters, "customer", $$v)},expression:"filters.customer"}},_vm._l((_vm.modCustomers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('el-form-item',[_vm._v("\n          课程类型:\n          "),_c('el-select',{attrs:{"filterable":"","placeholder":"课程类型"},model:{value:(_vm.filters.featureId),callback:function ($$v) {_vm.$set(_vm.filters, "featureId", $$v)},expression:"filters.featureId"}},_vm._l(([{id:'6',name:'大声说英语'},{id:'9',name:'萌宠'},{id:'19',name:'宝宝说英语'}]),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_vm._v("\n          卡密类型:\n          "),_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"卡密类型"},model:{value:(_vm.filters.cardType),callback:function ($$v) {_vm.$set(_vm.filters, "cardType", $$v)},expression:"filters.cardType"}},_vm._l(([{id:'all', name:'全部'},
                {id:'t4d365', name:'年卡'},
                {id:'d93', name:'季卡'},
                {id:'d62', name:'双月卡'},
                {id:'t3', name:'活动卡'},
                {id:'t1', name:'体验卡'},
                {id:'none', name:'无卡密'}
              ]),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")]),_vm._v(" "),_c('el-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.canPrint),expression:"canPrint"}],attrs:{"type":"primary","icon":"el-icon-download"},on:{"click":_vm.genPdf}},[_vm._v("生成PDF")])],1)],1),_vm._v(" "),_c('div',{staticClass:"duration"},[_c('span',{staticClass:"label"},[_vm._v("当前查询时间段：")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.dateRange[0])+" 至 "+_vm._s(_vm.dateRange[1]))])])],1),_vm._v(" "),_c('el-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.printingPDF),expression:"printingPDF"}],staticClass:"title"},[_c('h3',[_vm._v(_vm._s(_vm.modCustomers.find(function (e){ return e.id===_vm.filters.customer; }) 
        && _vm.modCustomers.find(function (e){ return e.id===_vm.filters.customer; }).name))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.dateRange[0])+" ~ "+_vm._s(_vm.dateRange[1]))])]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("线上出勤情况")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.attendance,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('pre',[_vm._v("        合格人数：自然周内，出勤天数大于等于5天  的用户数\n        总用户数：选定自然周内，有课程的用户数，包括在本周期内过期的用户数\n        占比=合格人数 / 总用户数")])]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("线上学习时长情况")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.learnDuration,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('pre',[_vm._v("        合格人数：自然周内，线上学习时长大于等于50分钟  的用户数\n        总用户数：选定自然周内，有课程的用户数，包括在本周期内过期的用户数\n        占比=合格人数 / 总用户数")])]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("星星获得情况")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.star,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('pre',[_vm._v("        合格人数：自然周内，星星获得大于15颗  的用户数\n        总用户数：选定自然周内，有课程的用户数，包括在本周期内过期的用户数\n        占比=合格人数 / 总用户数")])]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("巧口秀使用情况")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.qoocoshow,"resizable":true,"loading":_vm.loading}})],1),_vm._v(" "),_c('pre',[_vm._v("        合格人数：自然周内，巧口秀上传视频数量非0  的用户数\n        总用户数：选定自然周内，有课程的用户数，包括在本周期内过期的用户数\n        占比=合格人数 / 总用户数")])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      语吧周度对比\n      "),_c('small',[_vm._v("学习数据")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/learnDetails/learnDetails"}},[_vm._v("学习数据")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("语吧周度对比")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cU5d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cqvQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"filterable":"","clearable":"","placeholder":"学校"},on:{"change":_vm.changeSchool},model:{value:(_vm.filters.customer),callback:function ($$v) {_vm.$set(_vm.filters, "customer", $$v)},expression:"filters.customer"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{staticStyle:{"width":"300px"},attrs:{"filterable":"","clearable":"","placeholder":"班级"},model:{value:(_vm.filters.classId),callback:function ($$v) {_vm.$set(_vm.filters, "classId", $$v)},expression:"filters.classId"}},_vm._l((_vm.classes),function(item){return _c('el-option',{key:item.group_id,attrs:{"label":item.name,"value":item.group_id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1),_vm._v(" "),_c('div',{staticClass:"duration"},[_c('span',{staticClass:"label"},[_vm._v("当前查询时间段：")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.dateRange[0])+" 至 "+_vm._s(_vm.dateRange[1]))])])],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("运营详细数据")]),_vm._v(" "),_c('el-button',{attrs:{"id":"exportBtn","type":"primary","icon":"el-icon-download"},on:{"click":_vm.exportOperateDetails}},[_vm._v("导出")])],1),_vm._v(" "),_c('div',{staticClass:"sumTab"},[_c('table',{attrs:{"border":"2px solid rgba(216, 220, 229, 1)"}},[_c('tr',[_c('th',[_vm._v(" ")]),_vm._v(" "),_c('th',[_vm._v("当前有课率")]),_vm._v(" "),_c('th',[_vm._v("卡密充值总数")]),_vm._v(" "),_c('th',[_vm._v("两年卡充值总数")]),_vm._v(" "),_c('th',[_vm._v("年卡充值总数")]),_vm._v(" "),_c('th',[_vm._v("半年卡充值总数")]),_vm._v(" "),_c('th',[_vm._v("季卡充值总数")]),_vm._v(" "),_c('th',[_vm._v("两月卡充值总数")]),_vm._v(" "),_c('th',[_vm._v("月卡充值总数")]),_vm._v(" "),_c('th',[_vm._v("折合为月卡总数")]),_vm._v(" "),_c('th',[_vm._v("其他")])]),_vm._v(" "),_c('tr',[_c('th',[_vm._v("总计")]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.valid_package_rate))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.order_times))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.month_24))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.month_12))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.month_6))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.month_3))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.month_2))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.month_1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.convert_month_1))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.summary.month_13))])])])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('el-table',{attrs:{"border":"","data":_vm.operateDetails,"default-sort":{prop: 'date', order: 'descending'}},on:{"sort-change":_vm.sortChange}},[_c('el-table-column',{attrs:{"prop":"username","label":"学生名称","sortable":"custom","width":"230"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"packages","label":"当前课程名称","sortable":"custom","align":"center"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"times","label":"充值卡密次数","sortable":"custom","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"month_24","label":"充值两年卡次数","sortable":"custom","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"month_12","label":"充值年卡次数","sortable":"custom","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"month_6","label":"充值半年卡次数","sortable":"custom","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"month_3","label":"充值季卡次数","sortable":"custom","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"month_2","label":"充值两月卡次数","sortable":"custom","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"month_1","label":"充值月卡次数","sortable":"custom","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"convert_month_1","label":"折合为月卡张数","sortable":"custom","align":"center","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"month_13","label":"其他","sortable":"custom","align":"center","width":"80"}})],1),_vm._v(" "),_c('el-pagination',{attrs:{"current-page":_vm.page,"page-sizes":[10, 20, 30, 50, 100],"page-size":_vm.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      学生充值卡明细\n      "),_c('small',[_vm._v("充值卡综合数据")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/operateDetails/operateDetails"}},[_vm._v("充值卡综合数据")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("学生充值卡明细")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "dEMB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dpoh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_course_search_vue__ = __webpack_require__("9reN");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ee4506c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_course_search_vue__ = __webpack_require__("CWX2");
function injectStyle (ssrContext) {
  __webpack_require__("aIfx")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ee4506c8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_course_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ee4506c8_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_course_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "eKUs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',[_c('el-select',{staticStyle:{"width":"360px"},attrs:{"multiple":"","filterable":"","clearable":"","placeholder":"客户名称"},model:{value:(_vm.filters.customers),callback:function ($$v) {_vm.$set(_vm.filters, "customers", $$v)},expression:"filters.customers"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{attrs:{"filterable":"","placeholder":"课程选择"},model:{value:(_vm.filters.modeId),callback:function ($$v) {_vm.$set(_vm.filters, "modeId", $$v)},expression:"filters.modeId"}},_vm._l((_vm.modeList),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.val,"value":item.key}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1),_vm._v(" "),_c('div',{staticClass:"duration"},[_c('span',{staticClass:"label"},[_vm._v("当前查询时间段：")]),_vm._v(" "),_c('span',{staticClass:"value"},[_vm._v(_vm._s(_vm.dateRange[0])+" 至 "+_vm._s(_vm.dateRange[1]))])])],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("订单使用排行榜")]),_vm._v(" "),_c('el-button',{attrs:{"id":"exportBtn","type":"primary","icon":"el-icon-download"},on:{"click":function($event){return _vm.exportOrders('all')}}},[_vm._v("导出全部")])],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.otherSchool1 && !_vm.loading1),expression:"otherSchool1 && !loading1"}],staticClass:"other"},[_c('span',{staticClass:"school"},[_vm._v(_vm._s(_vm.otherSchool1))]),_vm._v(" "),_c('span',{staticClass:"order"},[_vm._v("订单（数量）："+_vm._s(_vm.otherOrder1))])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.orderUseRank,"resizable":true,"loading":_vm.loading1}})],1),_vm._v(" "),_c('el-pagination',{attrs:{"current-page":_vm.page1,"page-size":_vm.pageSize,"layout":"total, prev, pager, next","total":_vm.total1},on:{"current-change":_vm.handleCurrentChange1,"update:currentPage":function($event){_vm.page1=$event},"update:current-page":function($event){_vm.page1=$event}}})],1),_vm._v(" "),_c('el-card',{staticClass:"box-card half-left"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("MIS系统使用排行榜")]),_vm._v(" "),_c('el-button',{attrs:{"id":"exportBtn","type":"primary","icon":"el-icon-download"},on:{"click":function($event){return _vm.exportOrders('mys')}}},[_vm._v("导出全部")])],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.otherSchool2 && !_vm.loading2),expression:"otherSchool2 && !loading2"}],staticClass:"other"},[_c('span',{staticClass:"school"},[_vm._v(_vm._s(_vm.otherSchool2))]),_vm._v(" "),_c('span',{staticClass:"order"},[_vm._v("MIS系统（充值卡数量）："+_vm._s(_vm.otherOrder2))])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.mysUseRank,"resizable":true,"loading":_vm.loading2}})],1),_vm._v(" "),_c('el-pagination',{attrs:{"current-page":_vm.page2,"page-size":_vm.pageSize,"layout":"total, prev, pager, next","total":_vm.total2},on:{"current-change":_vm.handleCurrentChange2,"update:currentPage":function($event){_vm.page2=$event},"update:current-page":function($event){_vm.page2=$event}}})],1),_vm._v(" "),_c('el-card',{staticClass:"box-card half-right"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("用户使用排行榜")]),_vm._v(" "),_c('el-button',{attrs:{"id":"exportBtn","type":"primary","icon":"el-icon-download"},on:{"click":function($event){return _vm.exportOrders('card')}}},[_vm._v("导出全部")])],1),_vm._v(" "),_c('h4',{directives:[{name:"show",rawName:"v-show",value:(_vm.otherSchool3 && !_vm.loading3),expression:"otherSchool3 && !loading3"}],staticClass:"other"},[_c('span',{staticClass:"school"},[_vm._v(_vm._s(_vm.otherSchool3))]),_vm._v(" "),_c('span',{staticClass:"order"},[_vm._v("用户（充值卡数量）："+_vm._s(_vm.otherOrder3))])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.userUseRank,"resizable":true,"loading":_vm.loading3}})],1),_vm._v(" "),_c('el-pagination',{attrs:{"current-page":_vm.page3,"page-size":_vm.pageSize,"layout":"total, prev, pager, next","total":_vm.total3},on:{"current-change":_vm.handleCurrentChange3,"update:currentPage":function($event){_vm.page3=$event},"update:current-page":function($event){_vm.page3=$event}}})],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("所有订单类型充值情况展示")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.ordersSum,"resizable":true,"loading":_vm.loading5}})],1)]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("订单充值具体课程信息展示")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.modeOrders,"resizable":true,"loading":_vm.loading4}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      订单排行\n      "),_c('small',[_vm._v("订单综合排行榜")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/loudSpeakOperate/order"}},[_vm._v("订单综合排行榜")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("订单排行")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fLoV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gZoB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = delCookie;
/* unused harmony export setCookie */
/* unused harmony export getCookie */
function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + '=' + cval + ';expires=' + exp.toGMTString();
  }
}

function setCookie(name, value, time) {
  var exp = new Date();
  exp.setTime(exp.getTime() + time * 1);
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString();
}

function getCookie(name) {
  var arr = document.cookie;
  var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
  if (arr.match(reg)) {
    return unescape(arr[2]);
  } else {
    return null;
  }
}

/***/ }),

/***/ "ghal":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true,"model":_vm.filters}},[_c('el-form-item',[_c('el-select',{attrs:{"multiple":"","filterable":"","clearable":"","placeholder":"客户名称"},model:{value:(_vm.filters.customer),callback:function ($$v) {_vm.$set(_vm.filters, "customer", $$v)},expression:"filters.customer"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-select',{attrs:{"multiple":"","filterable":"","clearable":"","placeholder":"School ID"},model:{value:(_vm.filters.schoolId),callback:function ($$v) {_vm.$set(_vm.filters, "schoolId", $$v)},expression:"filters.schoolId"}},_vm._l((_vm.customers),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.id,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-date-picker',{attrs:{"type":"daterange","start-placeholder":"开始日期","end-placeholder":"结束日期","picker-options":_vm.pickerOptions,"default-value":_vm.currentDate,"value-format":"yyyy-MM-dd"},model:{value:(_vm.filters.dateRange),callback:function ($$v) {_vm.$set(_vm.filters, "dateRange", $$v)},expression:"filters.dateRange"}})],1),_vm._v(" "),_c('el-form-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('ROLE_QOOCO')),expression:"$auth.check('ROLE_QOOCO')"}]},[_c('el-select',{attrs:{"filterable":"","clearable":"","placeholder":"机构类型"},model:{value:(_vm.filters.orgType),callback:function ($$v) {_vm.$set(_vm.filters, "orgType", $$v)},expression:"filters.orgType"}},_vm._l((_vm.orgTypes),function(item){return _c('el-option',{key:item.id,attrs:{"label":item.name,"value":item.id}})}),1)],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("合作校平均学习时长排行榜")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.timeRanking,"resizable":true,"loading":_vm.loading}})],1)]),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("合作校平均学习时长分布")])]),_vm._v(" "),_c('div',{staticClass:"echart"},[_c('IEcharts',{attrs:{"option":_vm.timeSpread,"resizable":true,"loading":_vm.loading}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      学习时长数据\n      "),_c('small',[_vm._v("大声说英语学习数据")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/loudSpeakLearn/learnTime"}},[_vm._v("大声说英语学习数据")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("学习时长数据")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hLvu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadOrderUseRank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadMysUseRank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return loadUserUseRank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadOrdersSum; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadModeOrders; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadUserDetails; });
/* unused harmony export loadUserDataAnalyse */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("Dod7");

// tab1 订单运营数据
var loadOrderUseRank = function loadOrderUseRank(page, pageSize, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakOperate/orderUse/' + page + '/' + pageSize, params).then(function (res) {
    return res;
  });
};
var loadMysUseRank = function loadMysUseRank(page, pageSize, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakOperate/mysUse/' + page + '/' + pageSize, params).then(function (res) {
    return res;
  });
};
var loadUserUseRank = function loadUserUseRank(page, pageSize, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakOperate/userUse/' + page + '/' + pageSize, params).then(function (res) {
    return res;
  });
};
var loadOrdersSum = function loadOrdersSum(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakOperate/ordersSum', params).then(function (res) {
    return res;
  });
};
var loadModeOrders = function loadModeOrders(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakOperate/modeOrders', params).then(function (res) {
    return res;
  });
};

// tab2 用户运营数据
var loadUserDetails = function loadUserDetails(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakOperate/userDetails', params).then(function (res) {
    return res;
  });
};
var loadUserDataAnalyse = function loadUserDataAnalyse(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('loudSpeakOperate/userDataAnalyse', params).then(function (res) {
    return res;
  });
};

/***/ }),

/***/ "heVJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_api_loud_speak_learn__ = __webpack_require__("Xood");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__ = __webpack_require__("r/qW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_api_base__ = __webpack_require__("Dod7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery__ = __webpack_require__("fu2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jquery__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import {Loading} from 'element-ui'

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["b" /* mapGetters */])(['customers', 'pickerOptions', 'orgTypes'])),
  data: function data() {
    return {
      durationTabActive: 'avg',
      dateRange: [],
      currentDate: new Date(),
      filters: {
        customers: [],
        dateRange: [],
        orgType: ''
      },

      loading: true,
      timeRanking: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '25%', y: '14%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["g" /* subLabel */]
          }
        },
        series: [{
          name: '平均时长（分钟）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      totaltimeRanking: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '25%', y: '14%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: [],
          axisLabel: {
            rotate: -12,
            formatter: __WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["g" /* subLabel */]
          }
        },
        series: [{
          name: '总时长（分钟）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },

      timeSpread: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '15%', y: '14%', width: '70%', height: '75%' },
        xAxis: {
          data: []
        },
        yAxis: {},
        series: [{
          name: '学校（数目）',
          type: 'bar',
          data: [0, 0, 0, 0]
        }],
        color: ['rgb(91,155,213)']
      }
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_2_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    exportAllOrgDurs: function exportAllOrgDurs() {
      var form = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('<form>');
      form.attr('style', 'display:none');
      form.attr('target', '');
      form.attr('method', 'post');
      form.attr('action', __WEBPACK_IMPORTED_MODULE_6_api_base__["a" /* baseUrl */] + 'exports/exportAllOrgDurs');
      var input1 = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('<input>');
      var input2 = __WEBPACK_IMPORTED_MODULE_7_jquery___default()('<input>');
      input1.attr('type', 'hidden');
      input1.attr('name', 'conditionStr');
      input1.attr('value', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.filters));
      input2.attr('type', 'hidden');
      input2.attr('name', 'token');
      input2.attr('value', localStorage.getItem('default_auth_token'));
      __WEBPACK_IMPORTED_MODULE_7_jquery___default()('body').append(form);
      form.append(input1);
      form.append(input2);
      form.submit();
    },
    query: function query() {
      this._showDateRange();
      this._loadLearnTimeData(this.filters);
    },
    _showDateRange: function _showDateRange() {
      var t = this.filters.dateRange;
      if (t && t.length === 2) {
        this.dateRange = t;
      } else {
        this.dateRange = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["d" /* getLastWeek */])();
      }
    },
    _loadLearnTimeData: function _loadLearnTimeData() {
      var _this = this;

      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_4_api_loud_speak_learn__["b" /* loadLearnTimeData */])(this.filters).then(function (res) {
        _this.loading = false;
        _this.timeRanking.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["j" /* withRank */])(res.duration_ranking.keys.reverse(), res.duration_ranking.ranks.reverse());
        _this.timeRanking.series[0].data = res.duration_ranking.values.reverse();
        _this.timeSpread.xAxis.data = res.duration_spread.keys;
        _this.timeSpread.series[0].data = res.duration_spread.values;

        var arrs = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["b" /* extractArrsFromObj */])(res.total_duration_ranking, ['name', 'value', 'ranking']);
        _this.totaltimeRanking.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_5_common_js_app_utils__["j" /* withRank */])(arrs.name, arrs.ranking);
        _this.totaltimeRanking.series[0].data = arrs.value;
      }, function (msg) {
        _this.loading = false;
        _this._resetData();
        _this.$message.error(msg);
      });
    },
    _resetData: function _resetData() {
      this.timeRanking.yAxis.data = [];
      this.timeRanking.series[0].data = [];
      this.totaltimeRanking.yAxis.data = [];
      this.totaltimeRanking.series[0].data = [];
      this.timeSpread.xAxis.data = [];
      this.timeSpread.series[0].data = [];
    }
  }
});

/***/ }),

/***/ "ioI8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadRechargeCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadRechargeCardUsed; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadThreeRates; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadSubCourseRank; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return loadTimeSpread; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("Dod7");

// tab1 订单运营数据
var loadRechargeCard = function loadRechargeCard(page, pageSize, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('voipOperate/rechargeCard/' + page + '/' + pageSize, params).then(function (res) {
    return res;
  });
};
var loadRechargeCardUsed = function loadRechargeCardUsed(page, pageSize, params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('voipOperate/rechargeCardUsed/' + page + '/' + pageSize, params).then(function (res) {
    return res;
  });
};
var loadThreeRates = function loadThreeRates(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('voipOperate/threeRates', params).then(function (res) {
    return res;
  });
};
var loadSubCourseRank = function loadSubCourseRank(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('voipOperate/subCourseRank', params).then(function (res) {
    return res;
  });
};
var loadTimeSpread = function loadTimeSpread(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('voipOperate/timeSpread', params).then(function (res) {
    return res;
  });
};

/***/ }),

/***/ "jrL8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "kr4F":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('section',{staticClass:"content"},[_c('el-card',{staticClass:"box-card",attrs:{"body-style":"padding-bottom:0px"}},[_c('el-form',{attrs:{"inline":true}},[_c('el-form-item',[_c('el-input',{staticStyle:{"width":"470px"},attrs:{"placeholder":"请输入16位卡密号，多个卡号必须用逗号或空格分开（卡号1,卡号2,...）","clearable":""},model:{value:(_vm.cards),callback:function ($$v) {_vm.cards=$$v},expression:"cards"}})],1),_vm._v(" "),_c('el-form-item',[_c('el-button',{attrs:{"type":"primary","icon":"el-icon-search"},on:{"click":_vm.query}},[_vm._v("查询")])],1)],1)],1),_vm._v(" "),_c('el-card',{staticClass:"box-card"},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('span',{staticClass:"header-text"},[_vm._v("查询结果")])]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('el-tabs',{attrs:{"type":"card"},model:{value:(_vm.cardResultActive),callback:function ($$v) {_vm.cardResultActive=$$v},expression:"cardResultActive"}},[_c('el-tab-pane',{attrs:{"name":"valid"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("有效卡密 ("+_vm._s(_vm.validNum)+")")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"max-height":"300","data":_vm.valid_cardList,"border":""}},[_c('el-table-column',{attrs:{"prop":"card","label":"卡号","width":"150"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"valid_days","label":"有效期"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"used_status","label":"是否使用"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm._f("yesNo")(scope.row.used_status)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"usedByStudent","label":"被学生充值","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm._f("yesNo")(scope.row.usedByStudent)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"free_stats","label":"礼品免费卡","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('span',[_vm._v(_vm._s(_vm._f("yesNo")(scope.row.free_stats)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"voip_stats","label":"卡类型","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_id","label":"用户ID","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"user_name","label":"用户名","width":"80"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"nick","label":"昵称","width":"120"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"packages_info","label":"购买课程","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"create_day","label":"订购时间","width":"180"}})],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"delete"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("卡密已删出 ("+_vm._s(_vm.deleteNum)+")")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.delete_cardList,"border":""}},[_c('el-table-column',{attrs:{"prop":"card","label":"卡号"}})],1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"wrong"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_vm._v("卡密不存在 ("+_vm._s(_vm.wrongNum)+")")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.wrong_cardList,"border":""}},[_c('el-table-column',{attrs:{"prop":"card","label":"卡号"}})],1)],1)],1)],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"content-header"},[_c('h1',[_vm._v("\n      卡密查询\n      "),_c('small',[_vm._v("快速查询工具")])]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb"},[_c('li',[_c('a',{attrs:{"href":"#/"}},[_c('i',{staticClass:"fa fa-dashboard"}),_vm._v(" Home")])]),_vm._v(" "),_c('li',[_c('a',{attrs:{"href":"#/operateDetails/operateDetails"}},[_vm._v("快速查询工具")])]),_vm._v(" "),_c('li',{staticClass:"active"},[_vm._v("卡密查询")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lKd1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/user2-160x160.2e30e5d.jpg";

/***/ }),

/***/ "lUNs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_api_card_course_search__ = __webpack_require__("pcz7");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      // condition
      cards: '',
      // dialog
      dialogTableVisible: false,
      // pagination
      page: 1,
      total: 0,
      pageSize: 10,
      // tabs
      cardResultActive: 'valid',
      // business
      validNum: 0,
      deleteNum: 0,
      wrongNum: 0,
      valid_cardList: [],
      wrong_cardList: [],
      delete_cardList: []
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_0_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  filters: {
    yesNo: function yesNo(key) {
      switch (key) {
        case 'true':
          return '是';
        case 'false':
          return '否';
      }
    }
  },
  methods: {
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.query();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.query();
    },
    query: function query() {
      var _this = this;

      Object(__WEBPACK_IMPORTED_MODULE_1_api_card_course_search__["a" /* checkCard */])({ cards: this.cards }).then(function (res) {
        _this.valid_cardList = res.valid_cards;
        _this.wrong_cardList = _this._addCardKey(res.wrong_cards);
        _this.delete_cardList = _this._addCardKey(res.delete_cards);
        _this.validNum = res.valid_cards.length;
        _this.deleteNum = res.delete_cards.length;
        _this.wrongNum = res.wrong_cards.length;
        _this._setCardResultActive();
      }).catch(function (msg) {
        _this.$message.error(msg);
        _this.valid_cardList = [];
        _this.wrong_cardList = [];
        _this.delete_cardList = [];
        _this.validNum = 0;
        _this.deleteNum = 0;
        _this.wrongNum = 0;
      });
    },
    objectSpanMethod: function objectSpanMethod(_ref) {
      var row = _ref.row,
          column = _ref.column,
          rowIndex = _ref.rowIndex,
          columnIndex = _ref.columnIndex;

      if (columnIndex in [0, 1]) {
        if (row.multiFirst) {
          return {
            rowspan: row.multiTotal,
            colspan: 1
          };
        } else {
          return {
            rowspan: 0,
            colspan: 0
          };
        }
      }
    },
    _addCardKey: function _addCardKey(list) {
      var arr = [];
      list.forEach(function (t) {
        arr.push({ 'card': t });
      });
      return arr;
    },
    _setCardResultActive: function _setCardResultActive() {
      if (this.validNum > 0) {
        this.cardResultActive = 'valid';
      } else if (this.deleteNum > 0) {
        this.cardResultActive = 'delete';
      } else if (this.wrongNum > 0) {
        this.cardResultActive = 'wrong';
      } else {
        this.$message.error('所有输入卡密都不存在！');
      }
    }
  }
});

/***/ }),

/***/ "lk8A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lwq5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var state = {
  customers: [],
  pickerOptions: {},
  orgTypes: [],
  orgClasses: [],
  modeList: []
};

/* harmony default export */ __webpack_exports__["a"] = (state);

/***/ }),

/***/ "mSRY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_api_voip_operate__ = __webpack_require__("ioI8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__ = __webpack_require__("r/qW");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import {Loading} from 'element-ui'

/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["b" /* mapGetters */])(['customers', 'pickerOptions', 'orgTypes'])),
  data: function data() {
    return {
      currentPage1: 1,
      currentPage2: 1,
      total1: 0,
      total2: 0,
      pageSize: 10,

      currentDate: new Date(),
      filters: {
        customers: [],
        dateRange: [],
        orgType: ''
      },

      loading1: true,
      loading2: true,
      loading: true,
      useRate: 0,
      cancelRate: 0,
      continueRate: 0,
      rechargeCard: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['一对一', '一对多', '合计']
        },
        grid: { x: '17%', y: '14%', width: '70%', height: '75%' },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: []
        },
        series: [{
          name: '一对一',
          type: 'bar',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'inside'
            }
          },
          data: []
        }, {
          name: '一对多',
          type: 'bar',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'inside'
            }
          },
          data: []
        }, {
          name: '合计',
          type: 'bar',
          barWidth: 4,
          label: {
            normal: {
              show: true,
              position: 'right'
            }
          },
          data: []
        }],
        color: ['rgba(255, 0, 0, 1)', 'rgb(91,155,213)', 'rgba(34, 45, 50, 1)']
      },
      rechargeCardUse: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['一对一', '一对多', '合计']
        },
        grid: { x: '17%', y: '14%', width: '70%', height: '75%' },
        xAxis: {
          type: 'value'
        },
        yAxis: {
          type: 'category',
          data: ['school1', 'school1', 'school1', 'school1', 'school1']
        },
        series: [{
          name: '一对一',
          type: 'bar',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'inside'
            }
          },
          data: [1, 2, 3, 4, 10]
        }, {
          name: '一对多',
          type: 'bar',
          stack: '总量',
          label: {
            normal: {
              show: true,
              position: 'inside'
            }
          },
          data: [1, 2, 3, 4, 5]
        }, {
          name: '合计',
          type: 'bar',
          barWidth: 4,
          label: {
            normal: {
              show: true,
              position: 'right'
            }
          },
          data: [2, 4, 6, 8, 15]
        }],
        color: ['rgba(255, 0, 0, 1)', 'rgb(91,155,213)', 'rgba(34, 45, 50, 1)']
      },
      subOne2one: {
        title: {
          text: '一对一',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '25%', y: '14%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: []
        },
        series: [{
          name: '数量',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      subOne2many: {
        title: {
          text: '一对多',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis'
        },
        grid: { x: '25%', y: '14%', width: '70%', height: '75%' },
        xAxis: {},
        yAxis: {
          data: []
        },
        series: [{
          name: '时长（分钟）',
          type: 'bar',
          data: []
        }],
        color: ['rgb(91,155,213)']
      },
      durationSpread: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '14%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '技能分布',
          type: 'line',
          lineStyle: {
            normal: {
              width: 3,
              color: 'rgb(91,155,213)',
              shadowColor: 'rgba(0,0,0,0.4)',
              shadowBlur: 10,
              shadowOffsetY: 10
            }
          },
          data: [],
          color: ['rgb(91,155,213)']
        }]
      },
      weekSpread: {
        title: {
          text: ''
        },
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '14%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: [{
          name: '技能分布',
          type: 'line',
          lineStyle: {
            normal: {
              width: 3,
              color: 'rgb(91,155,213)',
              shadowColor: 'rgba(0,0,0,0.4)',
              shadowBlur: 10,
              shadowOffsetY: 10
            }
          },
          data: [],
          color: ['rgb(91,155,213)']
        }]
      }
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_1_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    handleCurrentChange1: function handleCurrentChange1(val) {
      this._loadRechargeCard(val, this.pageSize);
    },
    handleCurrentChange2: function handleCurrentChange2(val) {
      this._loadRechargeCardUsed(val, this.pageSize);
    },
    query: function query() {
      this._loadRechargeCard(1, this.pageSize);
      this._loadRechargeCardUsed(1, this.pageSize);
      this._loadThreeRates();
      this._loadSubCourseRank();
      this._loadTimeSpread();
    },
    _loadRechargeCard: function _loadRechargeCard(page, pageSize) {
      var _this = this;

      this.loading1 = true;
      Object(__WEBPACK_IMPORTED_MODULE_3_api_voip_operate__["a" /* loadRechargeCard */])(page, pageSize, this.filters).then(function (res) {
        _this.loading1 = false;
        var arrs = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["b" /* extractArrsFromObj */])(res.rows, ['school', 'one2one', 'one2many', 'all', 'rank']);
        _this.rechargeCard.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["j" /* withRank */])(arrs.school, arrs.rank);
        _this.rechargeCard.series[0].data = arrs.one2one;
        _this.rechargeCard.series[1].data = arrs.one2many;
        _this.rechargeCard.series[2].data = arrs.all;
        _this.total1 = res.total;
      }, function (msg) {
        _this.loading1 = false;
        _this.$message.error(msg);
      });
    },
    _loadRechargeCardUsed: function _loadRechargeCardUsed(page, pageSize) {
      var _this2 = this;

      this.loading2 = true;
      Object(__WEBPACK_IMPORTED_MODULE_3_api_voip_operate__["b" /* loadRechargeCardUsed */])(page, pageSize, this.filters).then(function (res) {
        _this2.loading2 = false;
        var arrs = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["b" /* extractArrsFromObj */])(res.rows, ['school', 'one2one', 'one2many', 'all', 'rank']);
        _this2.rechargeCardUse.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["j" /* withRank */])(arrs.school, arrs.rank);
        _this2.rechargeCardUse.series[0].data = arrs.one2one;
        _this2.rechargeCardUse.series[1].data = arrs.one2many;
        _this2.rechargeCardUse.series[2].data = arrs.all;
        _this2.total2 = res.total;
      }, function (msg) {
        _this2.loading2 = false;
        _this2.$message.error(msg);
      });
    },
    _loadThreeRates: function _loadThreeRates() {
      var _this3 = this;

      Object(__WEBPACK_IMPORTED_MODULE_3_api_voip_operate__["d" /* loadThreeRates */])(this.filters).then(function (res) {
        _this3.useRate = res.useRate;
        _this3.cancelRate = res.cancelRate;
        _this3.continueRate = res.continueRate;
      }, function (msg) {
        _this3.$message.error(msg);
      });
    },
    _loadSubCourseRank: function _loadSubCourseRank() {
      var _this4 = this;

      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_3_api_voip_operate__["c" /* loadSubCourseRank */])(this.filters).then(function (res) {
        _this4.loading = false;
        var arr1 = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["b" /* extractArrsFromObj */])(res.one2one, ['course', 'num', 'rank']);
        var arr2 = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["b" /* extractArrsFromObj */])(res.one2many, ['course', 'num', 'rank']);
        _this4.subOne2one.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["j" /* withRank */])(arr1.course, arr1.rank);
        _this4.subOne2one.series[0].data = arr1.num;
        _this4.subOne2many.yAxis.data = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["j" /* withRank */])(arr2.course, arr2.rank);
        _this4.subOne2many.series[0].data = arr2.num;
      }, function (msg) {
        _this4.loading = false;
        _this4.$message.error(msg);
      });
    },
    _loadTimeSpread: function _loadTimeSpread() {
      var _this5 = this;

      this.loading = true;
      Object(__WEBPACK_IMPORTED_MODULE_3_api_voip_operate__["e" /* loadTimeSpread */])(this.filters).then(function (res) {
        _this5.loading = false;
        var duration = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["e" /* parseTwoArray */])(res.duration);
        var week = Object(__WEBPACK_IMPORTED_MODULE_4_common_js_app_utils__["e" /* parseTwoArray */])(res.week);

        _this5.durationSpread.xAxis.data = duration.keys;
        _this5.durationSpread.series[0].data = duration.values;
        _this5.weekSpread.xAxis.data = week.keys;
        _this5.weekSpread.series[0].data = week.values;
      }, function (msg) {
        _this5.loading = false;
        _this5.$message.error(msg);
      });
    }
  }
});

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports) {



/***/ }),

/***/ "oCn3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_order_vue__ = __webpack_require__("TmyJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_633a1f58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_order_vue__ = __webpack_require__("eKUs");
function injectStyle (ssrContext) {
  __webpack_require__("NdhK")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-633a1f58"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_633a1f58_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_order_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "pVdt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pcz7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return checkCard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return checkPkg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return checkPkgHistory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("Dod7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_common_js_db__ = __webpack_require__("/foi");


// tab2 单个卡密查询
var checkCard = function checkCard(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["b" /* httpGet */])('cardPkg/checkCard', params).then(function (res) {
    return res;
  });
};
// tab1 用户课程查询
var checkPkg = function checkPkg(params) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["b" /* httpGet */])('cardPkg/checkPkg', params).then(function (res) {
    return res;
  });
};
// others
var checkPkgHistory = function checkPkgHistory(userId, pkgId) {
  // if (db.get(`${userId}-${pkgId}`)) {
  //   return new Promise((resolve, reject) => {
  //     resolve(db.get(`${userId}-${pkgId}`))
  //   })
  // }  为保证能查到实时数据，删除缓存代码
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["b" /* httpGet */])('cardPkg/checkPkgHistory/' + userId + '/' + pkgId).then(function (res) {
    __WEBPACK_IMPORTED_MODULE_1_common_js_db__["a" /* default */].set(userId + '-' + pkgId, res);
    return res;
  });
};

/***/ }),

/***/ "poY2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_card_search_vue__ = __webpack_require__("lUNs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3e126292_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_card_search_vue__ = __webpack_require__("kr4F");
function injectStyle (ssrContext) {
  __webpack_require__("bJQK")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3e126292"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_card_search_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_3e126292_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_card_search_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "qdC4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_vue__ = __webpack_require__("GZRF");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_19d96061_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_user_vue__ = __webpack_require__("WAKP");
function injectStyle (ssrContext) {
  __webpack_require__("zW8e")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-19d96061"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_user_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_19d96061_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_user_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "r/qW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["f"] = parseValueName;
/* harmony export (immutable) */ __webpack_exports__["e"] = parseTwoArray;
/* harmony export (immutable) */ __webpack_exports__["j"] = withRank;
/* harmony export (immutable) */ __webpack_exports__["a"] = extractArrFromObj;
/* harmony export (immutable) */ __webpack_exports__["b"] = extractArrsFromObj;
/* harmony export (immutable) */ __webpack_exports__["d"] = getLastWeek;
/* unused harmony export getLastMonth */
/* harmony export (immutable) */ __webpack_exports__["g"] = subLabel;
/* harmony export (immutable) */ __webpack_exports__["h"] = subLabelM;
/* harmony export (immutable) */ __webpack_exports__["i"] = tooltipWithSum;
/* harmony export (immutable) */ __webpack_exports__["c"] = fromClub;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__("HzJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__("KH7x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__("h3VH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_utils__ = __webpack_require__("tqEr");





/**
 * Echart所需数据生成 [{value:xxx,name:xxx},]
 * @param {Array} keys
 * @param {Array} values
 */
function parseValueName(keys, values) {
  var _array = [];
  keys.forEach(function (key, index) {
    var temp = { value: values[index], name: key };
    _array.push(temp);
  });
  return _array;
}

/**
 * Echart所需数据生成 解析一个json对象为两个数组{keys:[], values:[]}
 * @param {*} obj
 * @param {optional:Map} map 对象属性:对应的值 (不传入map则直接取obj[attr]为key)
 */
function parseTwoArray(obj, map) {
  map = map._c || '';
  var retObj = { keys: [], values: [] };
  if (map) {
    // map指定排序，指定key
    map.forEach(function (value, key) {
      retObj.keys.push(value);
      retObj.values.push(obj[key]);
    });
  } else {
    // obj默认排序，默认key
    var objMap = Object(__WEBPACK_IMPORTED_MODULE_3__common_utils__["e" /* objToMap */])(obj)._c;
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(objMap), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var _ref = _step.value;

        var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

        var key = _ref2[0];
        var value = _ref2[1];

        retObj.keys.push(key);
        retObj.values.push(value);
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }
  }
  return retObj;
}

/**
 * 追加排名
 * @param {Array} arr
 * @param {Array} ranks
 */
function withRank(arr, ranks) {
  var _array = [];
  arr.forEach(function (key, index) {
    var temp = key + ' [排名：' + ranks[index] + ']';
    _array.push(temp);
  });
  return _array;
}

/**
 * 从对象数组中，抽取指定一个属性的数组
 * @param {Object} objectArr
 * @param {string} attribute
 */
function extractArrFromObj(objectArr, attribute) {
  var _array = [];
  objectArr.forEach(function (object) {
    _array.push(object[attribute]);
  });
  return _array;
}

/**
 * 从对象数组中，抽取指定多个属性的数组
 * @param {Object} objectArr
 * @param {Array} attributes
 * @param {boolean} noReverse 数组不翻转；默认为false(翻转)
 */
function extractArrsFromObj(objectArr, attributes, noReverse) {
  var _object = {};
  attributes.forEach(function (attribute) {
    var _arr = [];
    if (noReverse) {
      _arr = extractArrFromObj(objectArr, attribute);
    } else {
      _arr = extractArrFromObj(objectArr, attribute).reverse();
    }
    _object[attribute] = _arr;
  });
  return _object;
}

/**
 *  最近一周
 */
function getLastWeek() {
  var lastMonday = __WEBPACK_IMPORTED_MODULE_2_moment___default()().day(1 - 7).format('YYYY-MM-DD');
  var lastSunday = __WEBPACK_IMPORTED_MODULE_2_moment___default()().day(0).format('YYYY-MM-DD');
  return [lastMonday, lastSunday];
}

/**
 * 最近一月
 */
function getLastMonth() {
  var lastMonthMonday = __WEBPACK_IMPORTED_MODULE_2_moment___default()().day(1 - 4 * 7).format('YYYY-MM-DD');
  var lastSunday = __WEBPACK_IMPORTED_MODULE_2_moment___default()().day(0).format('YYYY-MM-DD');
  return [lastMonthMonday, lastSunday];
}

/// formatters
/**
 * 柱状图Label自定义格式
 */
function subLabel(string) {
  var len_ = 30;
  return _subLabel(string, len_);
}

function subLabelM(string) {
  var len_ = 15;
  return _subLabel(string, len_);
}

function _subLabel(string, len_) {
  string = string.replace('[排名：', '[');
  var ScooId = string.indexOf('.') + 1;
  var rankS = string.indexOf('[');
  var rankE = string.indexOf(']') + 1;
  if (rankS > len_) {
    return string.substring(ScooId, len_).concat('...').concat(string.substring(rankS, rankE));
  } else {
    return string.substring(ScooId);
  }
}

/**
 * 自定义多层柱状图tooltip，显示总数
 */
function tooltipWithSum(array) {
  var sum = 0;
  var ret = '';
  ret += array[0].name + '<br/>';
  array.forEach(function (t) {
    sum += t.data;
    ret += t.marker + ' ' + t.seriesName + '\uFF1A ' + t.data + '<br/>';
  });
  ret += '\u5408\u8BA1\uFF1A' + sum;
  return ret;
}

function fromClub() {
  return window.location.search.indexOf('from=clubCRMP2Zyb209Y2x1YkNSTQ') > 0;
}

/***/ }),

/***/ "se3c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "t3m8":
/***/ (function(module, exports) {

//
//
//
//
//
//
//
//
//

/***/ }),

/***/ "tc/g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return loadOrgClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadCustomers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadClasses; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return loadModeList; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__base__ = __webpack_require__("Dod7");


var loadOrgClasses = function loadOrgClasses() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["b" /* httpGet */])('cond/orgClasses').then(function (res) {
    return res;
  });
};
var loadCustomers = function loadCustomers() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["b" /* httpGet */])('cond/customers').then(function (res) {
    return res;
  });
};
var loadClasses = function loadClasses(schoolIds) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["c" /* httpPost */])('cond/classes', schoolIds).then(function (res) {
    return res;
  });
};
var loadModeList = function loadModeList() {
  return Object(__WEBPACK_IMPORTED_MODULE_0__base__["b" /* httpGet */])('cond/modeList').then(function (res) {
    return res;
  });
};

/***/ }),

/***/ "tqEr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = objToMap;
/* harmony export (immutable) */ __webpack_exports__["d"] = objToKeyVal;
/* harmony export (immutable) */ __webpack_exports__["f"] = pagination;
/* harmony export (immutable) */ __webpack_exports__["g"] = sortChange;
/* harmony export (immutable) */ __webpack_exports__["b"] = download;
/* harmony export (immutable) */ __webpack_exports__["c"] = downloadForGet;
/* harmony export (immutable) */ __webpack_exports__["a"] = calcDays;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__("ZLEe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__("HzJ8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__("cUn4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__("fu2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);






/**
 * 将对象属性值转为map结构
 * @param {*} obj
 */
function objToMap(obj) {
  var map = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      map.set(key, obj[key]);
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return map;
}

/**
 * 将对象数组拆分为 key-val数组
 * @param {*} obj
 */
function objToKeyVal(obj) {
  var arr = [];
  var _iteratorNormalCompletion2 = true;
  var _didIteratorError2 = false;
  var _iteratorError2 = undefined;

  try {
    for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(obj)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
      var key = _step2.value;

      var obj_ = {};
      obj_['key'] = key;
      obj_['val'] = obj[key];
      arr.push(obj_);
    }
  } catch (err) {
    _didIteratorError2 = true;
    _iteratorError2 = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion2 && _iterator2.return) {
        _iterator2.return();
      }
    } finally {
      if (_didIteratorError2) {
        throw _iteratorError2;
      }
    }
  }

  return arr;
}

/**
 * 分页
 */
function pagination(page, pageSize, all) {
  var begin = (page - 1) * pageSize;
  var end = begin + pageSize;
  return all.slice(begin, end);
}

/**
 * 更改排序
 */
function sortChange(obj, all) {
  var _p = obj.prop;
  var isReverse = obj.order === 'descending';
  all.sort(function (a, b) {
    var _a = a[_p];
    var _b = b[_p];
    if (!isNaN(_a)) {
      _a = Number(_a);
      _b = Number(_b);
    }
    if (_a < _b) return isReverse ? 1 : -1;
    if (_a > _b) return isReverse ? -1 : 1;
    return 0;
  });
}

function download(url, options) {
  var form = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<form>');
  form.attr('style', 'display:none');
  form.attr('target', '');
  form.attr('method', 'post');
  form.attr('action', url);
  var tokenInput = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
  var typeInput = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
  tokenInput.attr('type', 'hidden');
  tokenInput.attr('name', 'token');
  tokenInput.attr('value', localStorage.getItem('default_auth_token'));
  typeInput.attr('type', 'hidden');
  typeInput.attr('name', 'options');
  typeInput.attr('value', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(options));
  __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').append(form);
  form.append(tokenInput);
  form.append(typeInput);
  form.submit();
}

function downloadForGet(url) {
  if (url.indexOf('?') === -1) {
    location.href = url + '?token=' + localStorage.getItem('default_auth_token');
  } else {
    location.href = url + '&token=' + localStorage.getItem('default_auth_token');
  }
}

/**
 *
 * @param {yyyy-mm-dd} from
 * @param {yyyy-mm-dd} to
 */
function calcDays(from, to) {
  return Math.abs((Date.parse(from) - Date.parse(to)) / 1000 / 60 / 60 / 24) + 1;
}

/***/ }),

/***/ "uMAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ukYY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("a3Yh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mutation_types__ = __webpack_require__("Du/2");


var _mutations;



var mutations = (_mutations = {}, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["a" /* SET_CUSTOMERS */], function (state, customers) {
  state.customers = customers;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["e" /* SET_PICKER_OPTIONS */], function (state, pickerOptions) {
  state.pickerOptions = pickerOptions;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["d" /* SET_ORG_TYPES */], function (state, orgTypes) {
  state.orgTypes = orgTypes;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["c" /* SET_ORG_CLASSES */], function (state, orgClasses) {
  state.orgClasses = orgClasses;
}), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_mutations, __WEBPACK_IMPORTED_MODULE_1__mutation_types__["b" /* SET_MODE_LIST */], function (state, modeList) {
  state.modeList = modeList;
}), _mutations);

/* harmony default export */ __webpack_exports__["a"] = (mutations);

/***/ }),

/***/ "ulG/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[(!_vm.fromClub())?_c('header',{staticClass:"main-header"},[_vm._m(0),_vm._v(" "),_c('nav',{staticClass:"navbar navbar-static-top"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"navbar-custom-menu"},[_c('ul',{staticClass:"nav navbar-nav"},[_c('li',{staticClass:"dropdown user user-menu"},[_c('a',{staticClass:"dropdown-toggle",attrs:{"href":"#","data-toggle":"dropdown"}},[_c('img',{staticClass:"user-image",attrs:{"src":__webpack_require__("lKd1"),"alt":"User Image"}}),_vm._v(" "),_c('span',{staticClass:"hidden-xs"},[_vm._v(_vm._s(_vm.$auth.user().nickname))])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_c('li',{staticClass:"user-header"},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__("lKd1"),"alt":"User Image"}}),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.$auth.user().nickname)+" - "+_vm._s(_vm.$auth.user().roles[0].replace("ROLE_",""))+"\n                ")])]),_vm._v(" "),_c('li',{staticClass:"user-footer"},[(_vm.$auth.check())?_c('div',{staticClass:"pull-left"},[_c('a',{staticClass:"btn btn-default btn-flat",attrs:{"href":"#","disabled":""}},[_vm._v("更改密码")])]):_vm._e(),_vm._v(" "),(_vm.$auth.check())?_c('div',{staticClass:"pull-right"},[_c('a',{staticClass:"btn btn-default btn-flat",on:{"click":_vm.logout}},[_vm._v("退出")])]):_vm._e()])])])])])])]):_vm._e(),_vm._v(" "),_c('aside',{staticClass:"main-sidebar",style:(_vm.fromClub()?'padding-top:20px':'')},[(_vm.fromClub())?_c('a',{staticStyle:{"cursor":"pointer","width":"100%","height":"20px","position":"absolute","background":"rgb(91, 155, 213)","top":"0","left":"0","right":"-30px"},on:{"click":_vm.toggleSidebar}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")])]):_vm._e(),_vm._v(" "),_c('section',{staticClass:"sidebar"},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fromClub()),expression:"!fromClub()"}],staticClass:"user-panel"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"pull-left info"},[_c('p',[_vm._v(_vm._s(_vm.$auth.user().nickname))]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),(_vm.$auth.ready())?_c('ul',{staticClass:"sidebar-menu",attrs:{"data-widget":"tree"}},[_c('li',{directives:[{name:"show",rawName:"v-show",value:(!_vm.fromClub()),expression:"!fromClub()"}],staticClass:"header"},[_vm._v("功能菜单")]),_vm._v(" "),_vm._l((_vm.filteredRouter),function(item){return [(item.children)?_c('li',{key:item.alias,staticClass:"treeview"},[_c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-folder"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.alias))]),_vm._v(" "),_vm._m(4,true)]),_vm._v(" "),_c('ul',{staticClass:"treeview-menu"},_vm._l((item.children),function(child){return _c('router-link',{directives:[{name:"show",rawName:"v-show",value:(!child.hidden && (!child.meta || (_vm.$auth.check(child.meta.auth.roles)&&!_vm.isQooco()) || _vm.hasPermission('/das' + child.path))),expression:"!child.hidden && (!child.meta || ($auth.check(child.meta.auth.roles)&&!isQooco()) || hasPermission('/das' + child.path))"}],key:child.alias,attrs:{"tag":"li","to":child.path}},[_c('a',[_c('i',{staticClass:"fa fa-circle-o text-aqua"}),_vm._v(_vm._s(child.alias)+"\n                ")])])}),1)]):_vm._e(),_vm._v(" "),(!item.children)?_c('router-link',{key:item.alias,attrs:{"tag":"li","to":item.path}},[_c('a',[_c('i',{staticClass:"fa fa-circle-o text-aqua"}),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.alias))])])]):_vm._e()]})],2):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"content-wrapper",style:(_vm.fromClub()?'padding-top:0':'')},[_c('keep-alive',[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"clearfloat"})],1),_vm._v(" "),(!_vm.fromClub())?_c('footer',{staticClass:"main-footer"},[_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" All rights\n    reserved.\n  ")]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"logo",attrs:{"href":"#/"}},[_c('span',{staticClass:"logo-mini"},[_c('b',[_vm._v("D")]),_vm._v("AS")]),_vm._v(" "),_c('span',{staticClass:"logo-lg"},[_c('b',[_vm._v("Qooco")]),_vm._v("DAS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"sidebar-toggle",attrs:{"href":"#","data-toggle":"push-menu","role":"button"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-left image"},[_c('img',{staticClass:"img-circle",attrs:{"src":__webpack_require__("lKd1"),"alt":"User Image"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-circle text-success"}),_vm._v(" Online")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pull-right-container"},[_c('i',{staticClass:"fa fa-angle-left pull-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pull-right hidden-xs"},[_c('b',[_vm._v("Version")]),_vm._v(" 1.0.0\n    ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',[_vm._v("Copyright © 2017-2018 "),_c('a',{attrs:{"href":"http://www.qooco.com/"}},[_vm._v("Qooco")]),_vm._v(".")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uxEr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wqmp":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_details_qoocobar_vue__ = __webpack_require__("85SI");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7936b590_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_details_qoocobar_vue__ = __webpack_require__("DaJ5");
function injectStyle (ssrContext) {
  __webpack_require__("pVdt")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7936b590"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_learn_details_qoocobar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_7936b590_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_learn_details_qoocobar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "z57w":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zCZ4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_home_vue__ = __webpack_require__("77ao");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ce125272_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_home_vue__ = __webpack_require__("ulG/");
function injectStyle (ssrContext) {
  __webpack_require__("fLoV")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ce125272"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_ce125272_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zW8e":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zrQv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_operate_details_vue__ = __webpack_require__("zxfe");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9a2b31f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_operate_details_vue__ = __webpack_require__("cqvQ");
function injectStyle (ssrContext) {
  __webpack_require__("+g9V")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-9a2b31f4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_operate_details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_9a2b31f4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_operate_details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "zxfe":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__("IHPB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("3cXf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__("4YfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_echarts_v3_src_full__ = __webpack_require__("/SR6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery__ = __webpack_require__("fu2u");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_api_base__ = __webpack_require__("Dod7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__("2bvH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_common_js_app_utils__ = __webpack_require__("r/qW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_common_js_common_utils__ = __webpack_require__("tqEr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_api_operate_details__ = __webpack_require__("B0rx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_api_condition__ = __webpack_require__("tc/g");



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["b" /* mapGetters */])(['customers', 'pickerOptions', 'orgTypes'])),
  data: function data() {
    return {
      currentDate: new Date(),
      dateRange: [],
      classes: [],
      filters: {
        customer: '',
        classId: '',
        dateRange: [],
        orgType: ''
      },
      // pagination
      page: 1,
      total: 0,
      pageSize: 10,
      userListAll: [],
      // business
      operateDetails: [],
      summary: {}
    };
  },

  components: {
    IEcharts: __WEBPACK_IMPORTED_MODULE_3_vue_echarts_v3_src_full__["a" /* default */]
  },
  mounted: function mounted() {
    this.query();
  },

  methods: {
    sortChange: function sortChange(obj) {
      Object(__WEBPACK_IMPORTED_MODULE_8_common_js_common_utils__["g" /* sortChange */])(obj, this.userListAll);
      this.handleCurrentChange(1);
    },
    pagination: function pagination(page, pageSize, all) {
      this.operateDetails = Object(__WEBPACK_IMPORTED_MODULE_8_common_js_common_utils__["f" /* pagination */])(page, pageSize, all);
      this.total = all.length;
    },
    changeSchool: function changeSchool(val) {
      this.filters.classId = '';
      this._loadClasses();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.pagination(1, val, this.userListAll);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.page = val;
      this.pagination(val, this.pageSize, this.userListAll);
    },
    exportOperateDetails: function exportOperateDetails() {
      var form = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<form>');
      form.attr('style', 'display:none');
      form.attr('target', '');
      form.attr('method', 'post');
      form.attr('action', __WEBPACK_IMPORTED_MODULE_5_api_base__["a" /* baseUrl */] + 'exports/exportOperateDetails');
      var input1 = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
      var input2 = __WEBPACK_IMPORTED_MODULE_4_jquery___default()('<input>');
      input1.attr('type', 'hidden');
      input1.attr('name', 'conditionStr');
      input1.attr('value', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.filters));
      input2.attr('type', 'hidden');
      input2.attr('name', 'token');
      input2.attr('value', localStorage.getItem('default_auth_token'));
      __WEBPACK_IMPORTED_MODULE_4_jquery___default()('body').append(form);
      form.append(input1);
      form.append(input2);
      form.submit();
    },
    query: function query() {
      this._showDateRange();
      this._loadPackagesOrders(this.filters);
    },
    _showDateRange: function _showDateRange() {
      var t = this.filters.dateRange;
      if (t && t.length === 2) {
        this.dateRange = t;
      } else {
        this.dateRange = Object(__WEBPACK_IMPORTED_MODULE_7_common_js_app_utils__["d" /* getLastWeek */])();
      }
    },
    _loadPackagesOrders: function _loadPackagesOrders() {
      var _this = this;

      this.page = 1;
      Object(__WEBPACK_IMPORTED_MODULE_9_api_operate_details__["a" /* loadPackagesOrders */])(this.filters).then(function (res) {
        _this.summary = res.summary;
        _this.userListAll = _this._wrapUserList(res.user_list);
        _this.handleSizeChange(_this.pageSize);
      }, function (msg) {
        _this.$message.error(msg);
        _this.summary = {};
        _this.userListAll = [];
        _this.handleSizeChange(_this.pageSize);
      });
    },
    _loadClasses: function _loadClasses() {
      var _this2 = this;

      // 接口只接受多选，所以这里需要将单选转为多选
      var orgId = this.filters.customer;
      var schoolIds = [orgId];
      Object(__WEBPACK_IMPORTED_MODULE_10_api_condition__["a" /* loadClasses */])(schoolIds).then(function (res) {
        var ret = [];
        Object(__WEBPACK_IMPORTED_MODULE_7_common_js_app_utils__["a" /* extractArrFromObj */])(res, 'groups').every(function (arr) {
          return ret.push.apply(ret, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(arr));
        });
        _this2.classes = ret;
      }, function (msg) {
        _this2.classes = [];
      });
    },
    _wrapUserList: function _wrapUserList(rawUserList) {
      var defaultOrders = { times: '-', month_1: '-', month_3: '-', month_6: '-', month_12: '-', month_13: '-', convert_month_1: '-' };
      var userList = [];
      rawUserList.forEach(function (user) {
        var _user = {};
        _user.userid = user.userid;
        _user.username = user.username;
        _user.packages = user.packages || '-';
        var _orders = user.orders || defaultOrders;
        _user.times = _orders.times;
        _user.month_1 = _orders.month_1;
        _user.month_2 = _orders.month_2;
        _user.month_3 = _orders.month_3;
        _user.month_6 = _orders.month_6;
        _user.month_12 = _orders.month_12;
        _user.month_24 = _orders.month_24;
        _user.month_13 = _orders.month_13;
        _user.convert_month_1 = _orders.convert_month_1;
        userList.push(_user);
      });
      return userList;
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.dbbf452c053d00d2c39f.js